{
  "schemaVersion": 2,
  "id": "player-card",
  "stage": {
    "w": 941,
    "h": 1672
  },
  "stageScaleBase": {
    "w": 941,
    "h": 1672
  },
  "units": "stage units; slicePx and sourceRect are source-image pixels",
  "sourceRoot": "repository root",
  "reference": "art/src/player-card-2026-10-07/reference/reference-boxes.json",
  "round10": "art/src/player-card-2026-10-07/rounds/round-10-offsets.json",
  "brief": "art/src/player-card-2026-10-07/BRIEF-CODEX-4.md",
  "defaultTheme": "female",
  "defaultState": "intro",
  "reviewStatus": "stage-4 photo-print correction for owner review; no application implementation",
  "pieces": {
    "pill.large.png": {
      "path": "apps/client/public/art/lobby-kit/pill.large.png",
      "pixelW": 764,
      "pixelH": 248,
      "alpha": true,
      "alphaRange": [
        0,
        254
      ],
      "transparentPixels": 27877,
      "partialAlphaPixels": 161595,
      "sha256": "ef0dfd59006c43eb404b312696ed4ad5c96f389f880acf85fcb3aaa1ca6de8e3",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 124,
        "bottom": 0,
        "left": 124
      },
      "origin": "CrewSheet .mc-chip / .mc-field; native alpha retained"
    },
    "create.pill.off": {
      "path": "apps/client/public/art/create-kit/pill.off.png",
      "pixelW": 247,
      "pixelH": 140,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 10422,
      "partialAlphaPixels": 24141,
      "sha256": "4e4c0d8bfeb8c1fcaabb2a0cb9f02c3979a9a723a189da8df7ebaab469d32cb2",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "origin": "layout-create.json: create.pill.off; pill.on is not used"
    },
    "cta.plate.png": {
      "path": "apps/client/public/art/lobby-kit/cta.plate.png",
      "pixelW": 1736,
      "pixelH": 326,
      "alpha": true,
      "alphaRange": [
        0,
        254
      ],
      "transparentPixels": 56991,
      "partialAlphaPixels": 508945,
      "sha256": "ae9529479f4f35a908b8acd3f2e196be029ae229eb90d3b4dc969e7d8e7dcdde",
      "reused": true,
      "slicePx": {
        "top": 0,
        "right": 331,
        "bottom": 0,
        "left": 331
      },
      "origin": "CrewSheet .mc-send; no tint"
    },
    "icon.clock": {
      "path": "apps/client/public/art/lobby-kit/icon.clock.png",
      "pixelW": 80,
      "pixelH": 80,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 5146,
      "partialAlphaPixels": 908,
      "sha256": "5617a2e8154691b49305170c56d2af023670f67e7379dac5f015518d9362a29b",
      "reused": true
    },
    "icon.paper-plane": {
      "path": "apps/client/public/art/lobby-kit/icon.paper-plane.png",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 32345,
      "partialAlphaPixels": 1310,
      "sha256": "1ebf164032b6d614a3da2e8210aab9cfb0f6513f3d396161c7faee80976b549c",
      "reused": true
    },
    "heart": {
      "path": "apps/client/public/art/lobby-kit/heart.png",
      "pixelW": 96,
      "pixelH": 204,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 15168,
      "partialAlphaPixels": 4252,
      "sha256": "6c27fca84e28a7052a97273f32a7087ca29d88d5625c3071b71b2da5bf33fc53",
      "reused": true
    },
    "symbol.female": {
      "path": "apps/client/public/art/ui4b/icon-female@2x.png",
      "pixelW": 92,
      "pixelH": 122,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 2404,
      "partialAlphaPixels": 8756,
      "sha256": "8a7c786fe0e6389ceb267f178d9cf9d0870aaa4b9e6b47e72639c4726514d9da",
      "reused": true
    },
    "symbol.male": {
      "path": "apps/client/public/art/ui4b/icon-male@2x.png",
      "pixelW": 92,
      "pixelH": 93,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 4475,
      "partialAlphaPixels": 3866,
      "sha256": "6388367e2ffc1eb219b1e521ca3f97cbd862bc4d62eeff99981bfe67015a45a2",
      "reused": true
    },
    "symbol.star": {
      "path": "apps/client/public/art/ui4b/icon-star@2x.png",
      "pixelW": 92,
      "pixelH": 87,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 4681,
      "partialAlphaPixels": 3169,
      "sha256": "84a1ead3e6e239c6ed675f2d3d7f2db5fa8a30b43f0bb7afd9081e793857e346",
      "reused": true
    },
    "close": {
      "path": "apps/client/public/art/ui4b/btn-close-x@2x.png",
      "pixelW": 232,
      "pixelH": 232,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 20528,
      "partialAlphaPixels": 33151,
      "sha256": "7fd5fd82aeacc15f679fbe74cfe7e10b3770f0b82185a02a14dd3c2287f020d3",
      "reused": true
    },
    "quote.open": {
      "path": "art/src/player-card-2026-10-07/pieces/icon.quote.open.png",
      "pixelW": 264,
      "pixelH": 205,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 26037,
      "partialAlphaPixels": 27622,
      "sha256": "ea2bcab23f25b658bfadd383f90f3787e399a36d3aeb7fd16c403417e90fee9e",
      "reused": true
    },
    "quote.close": {
      "path": "art/src/player-card-2026-10-07/pieces/icon.quote.close.png",
      "pixelW": 262,
      "pixelH": 203,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 25397,
      "partialAlphaPixels": 27284,
      "sha256": "20bb02d3d23eb213e44dcf3d25249813c640824c7c2769372e446c650457e2bb",
      "reused": true
    },
    "card.base.female": {
      "path": "art/src/player-card-2026-10-07/pieces/card.base.female.png",
      "pixelW": 856,
      "pixelH": 1143,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 29522,
      "partialAlphaPixels": 948725,
      "sha256": "0a21eb36ad2b73970e40d2e2ea0164cf0b44f98d263ca22ccdf7243823701b58",
      "reused": true,
      "source": "work/card.base.female.stage1c.registered-draft.png",
      "status": "existing review candidate; master resolution and artwork approval pending",
      "slicePx": {
        "top": 332,
        "right": 126,
        "bottom": 197,
        "left": 126
      },
      "sliceProvenance": {
        "nativePx": {
          "top": 420,
          "right": 160,
          "bottom": 250,
          "left": 160
        },
        "nativeDimensions": [
          1084,
          1451
        ],
        "registrationScale": 0.7898338220918866
      },
      "contains": [
        "double frame",
        "palms",
        "sparkles",
        "crown",
        "large theme symbol",
        "decorative hearts or stars"
      ],
      "excludes": [
        "player data",
        "portraits",
        "print frames",
        "pills",
        "quotes",
        "Send Message",
        "close",
        "timer"
      ]
    },
    "avatar.female.happy": {
      "path": "apps/client/public/avatars/cast/snw-cast-0001/happy.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 33639,
      "partialAlphaPixels": 31506,
      "sha256": "3bc6b3e0bc4d20d9f2278ec63aacc52341091d0b9d25a18c44fb1dbdac133620",
      "reused": true,
      "avatarId": "snw-cast-0001",
      "expression": "happy"
    },
    "avatar.female.victory": {
      "path": "apps/client/public/avatars/cast/snw-cast-0001/victory.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 32455,
      "partialAlphaPixels": 32631,
      "sha256": "a74ccb7dfb26d7ce5c117d4c47cace4974cfc41588b6cabc48fdbbab070ae961",
      "reused": true,
      "avatarId": "snw-cast-0001",
      "expression": "victory"
    },
    "avatar.female.thinking": {
      "path": "apps/client/public/avatars/cast/snw-cast-0001/thinking.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 37659,
      "partialAlphaPixels": 27500,
      "sha256": "c39e8fad89bd7ce8b6ce98127fa43132127843f9f0abf6fa03e0f1d81ecb6a0d",
      "reused": true,
      "avatarId": "snw-cast-0001",
      "expression": "thinking"
    },
    "avatar.female.flirt": {
      "path": "apps/client/public/avatars/cast/snw-cast-0001/flirt.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 41425,
      "partialAlphaPixels": 23739,
      "sha256": "fd0e9c94eb72406e439f2eebe8871afac16d15f32741f7d9aa31495fb6ff95c7",
      "reused": true,
      "avatarId": "snw-cast-0001",
      "expression": "flirt"
    },
    "card.base.male": {
      "path": "art/src/player-card-2026-10-07/pieces/card.base.male.png",
      "pixelW": 857,
      "pixelH": 1143,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 47378,
      "partialAlphaPixels": 931953,
      "sha256": "2b82a890873e366985221011552897d4b7fc2935d08b8700478fb32af6e9ae8b",
      "reused": true,
      "source": "work/card.base.male.stage1c.registered-draft.png",
      "status": "existing review candidate; master resolution and artwork approval pending",
      "slicePx": {
        "top": 332,
        "right": 126,
        "bottom": 198,
        "left": 126
      },
      "sliceProvenance": {
        "nativePx": {
          "top": 420,
          "right": 160,
          "bottom": 250,
          "left": 160
        },
        "nativeDimensions": [
          1084,
          1451
        ],
        "registrationScale": 0.7903543307086615
      },
      "contains": [
        "double frame",
        "palms",
        "sparkles",
        "crown",
        "large theme symbol",
        "decorative hearts or stars"
      ],
      "excludes": [
        "player data",
        "portraits",
        "print frames",
        "pills",
        "quotes",
        "Send Message",
        "close",
        "timer"
      ]
    },
    "avatar.male.happy": {
      "path": "apps/client/public/avatars/cast/snw-cast-0002/happy.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 37482,
      "partialAlphaPixels": 27664,
      "sha256": "1951460e15541fcd06cb23786107ec88932e504de9c53d49841534c5c1647d5d",
      "reused": true,
      "avatarId": "snw-cast-0002",
      "expression": "happy"
    },
    "avatar.male.victory": {
      "path": "apps/client/public/avatars/cast/snw-cast-0002/victory.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 34010,
      "partialAlphaPixels": 30961,
      "sha256": "c308ea67efc8de67e8b6a0e015ea26511276ab95569b7bd139b308cb57c805ea",
      "reused": true,
      "avatarId": "snw-cast-0002",
      "expression": "victory"
    },
    "avatar.male.thinking": {
      "path": "apps/client/public/avatars/cast/snw-cast-0002/thinking.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 36901,
      "partialAlphaPixels": 28233,
      "sha256": "2ec178e7563b45f94b9577e795a7a556df01b28d7114f2768717e552cfcd0ccb",
      "reused": true,
      "avatarId": "snw-cast-0002",
      "expression": "thinking"
    },
    "avatar.male.flirt": {
      "path": "apps/client/public/avatars/cast/snw-cast-0002/flirt.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 39798,
      "partialAlphaPixels": 25320,
      "sha256": "ea1f3c99d8ed866cb39949abebb862b00f09e1d9245835ec26c923be0922cbac",
      "reused": true,
      "avatarId": "snw-cast-0002",
      "expression": "flirt"
    },
    "card.base.other": {
      "path": "art/src/player-card-2026-10-07/pieces/card.base.other.png",
      "pixelW": 852,
      "pixelH": 1141,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 48008,
      "partialAlphaPixels": 924092,
      "sha256": "814308038b09d458486ffac40640c5508cc4a518d3410defbab1d53ff6c24419",
      "reused": true,
      "source": "work/card.base.other.stage1c.registered-draft.png",
      "status": "existing review candidate; master resolution and artwork approval pending",
      "slicePx": {
        "top": 330,
        "right": 126,
        "bottom": 197,
        "left": 126
      },
      "sliceProvenance": {
        "nativePx": {
          "top": 420,
          "right": 160,
          "bottom": 250,
          "left": 160
        },
        "nativeDimensions": [
          1084,
          1451
        ],
        "registrationScale": 0.7863414634146342
      },
      "contains": [
        "double frame",
        "palms",
        "sparkles",
        "crown",
        "large theme symbol",
        "decorative hearts or stars"
      ],
      "excludes": [
        "player data",
        "portraits",
        "print frames",
        "pills",
        "quotes",
        "Send Message",
        "close",
        "timer"
      ]
    },
    "avatar.other.happy": {
      "path": "apps/client/public/avatars/cast/snw-cast-0007/happy.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 35774,
      "partialAlphaPixels": 29293,
      "sha256": "e9de049889c3d1ee1b0f455a9b27fbaffd1e8525f19392a4dfcbeed8e0052025",
      "reused": true,
      "avatarId": "snw-cast-0007",
      "expression": "happy"
    },
    "avatar.other.victory": {
      "path": "apps/client/public/avatars/cast/snw-cast-0007/victory.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 39228,
      "partialAlphaPixels": 25924,
      "sha256": "c0a3e120395b75453bfbf926a8e93f75e041e795d4730c28d43351087a21e088",
      "reused": true,
      "avatarId": "snw-cast-0007",
      "expression": "victory"
    },
    "avatar.other.thinking": {
      "path": "apps/client/public/avatars/cast/snw-cast-0007/thinking.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 38119,
      "partialAlphaPixels": 26985,
      "sha256": "dfb94e4e0ad21a45ca010c66c1f00469a998fe346b55de2c0e0074c2db8683e2",
      "reused": true,
      "avatarId": "snw-cast-0007",
      "expression": "thinking"
    },
    "avatar.other.flirt": {
      "path": "apps/client/public/avatars/cast/snw-cast-0007/flirt.webp",
      "pixelW": 256,
      "pixelH": 256,
      "alpha": true,
      "alphaRange": [
        0,
        255
      ],
      "transparentPixels": 37175,
      "partialAlphaPixels": 27955,
      "sha256": "3fa12c860d973f0bc32351221f8a6790dd53c104798f8414962d3dc8c693167d",
      "reused": true,
      "avatarId": "snw-cast-0007",
      "expression": "flirt"
    },
    "print.1": {
      "path": "art/src/player-card-2026-10-07/pieces/publish/print.1.png",
      "pixelW": 210,
      "pixelH": 270,
      "alpha": true,
      "alphaRange": [
        255,
        255
      ],
      "transparentPixels": 0,
      "partialAlphaPixels": 0,
      "sha256": "ebe8eb919aad69b2e4003427f244da05bc7d0948502b3cb66b18382c4e288a8e",
      "reused": false,
      "master": {
        "path": "art/src/player-card-2026-10-07/pieces/print.1.png",
        "pixelW": 900,
        "pixelH": 1158,
        "scale": 6,
        "sha256": "f4493cc247046a757cc67fda0089bf7290be61aa5fbf20bb94d6a78406633bca"
      },
      "drawnSize": {
        "w": 150,
        "h": 193
      },
      "publishScale": 1.4,
      "publishRounding": "round each drawn dimension × 1.4: 210 × 270 px",
      "window": {
        "x": 7,
        "y": 8,
        "w": 136,
        "h": 144
      },
      "contains": [
        "white paper",
        "own opaque neon-palm scene",
        "baked graphic caption and outlined heart"
      ],
      "excludes": [
        "avatar",
        "live text"
      ],
      "bakedCaption": "GOOD VIBES ♡",
      "generation": "built-in image_gen.imagegen; prompt and native source in work/stage4-generation-prompts.json",
      "registration": {
        "sourceDimensions": [
          1105,
          1423
        ],
        "sourceWindow": {
          "x": 38,
          "y": 35,
          "w": 1031,
          "h": 1023
        },
        "sceneFit": "uniform cover",
        "captionFit": "uniform scale to the reference 41-unit paper band; no retyping or font",
        "frame": "generated paper strips registered to reference 7 side / 8 top / 41 bottom",
        "nativeSourceScale": [
          7.366666666666666,
          7.373056994818653
        ]
      },
      "opaqueRule": "entire paper and photo scene alpha 255; avatar transparency reveals this scene",
      "renderRule": "one uniformly scaled complete plate; no slicing, tinting, additional frame or caption layer"
    },
    "print.2": {
      "path": "art/src/player-card-2026-10-07/pieces/publish/print.2.png",
      "pixelW": 210,
      "pixelH": 270,
      "alpha": true,
      "alphaRange": [
        255,
        255
      ],
      "transparentPixels": 0,
      "partialAlphaPixels": 0,
      "sha256": "7368cd1bd008e577534ef3479bca92b19c73a8198847c2ceb72f4761dece19ae",
      "reused": false,
      "master": {
        "path": "art/src/player-card-2026-10-07/pieces/print.2.png",
        "pixelW": 900,
        "pixelH": 1158,
        "scale": 6,
        "sha256": "092ff364f767625fe877fd3caf401ee626e2adcb1f4b4c4ab582239a2eb3c5e1"
      },
      "drawnSize": {
        "w": 150,
        "h": 193
      },
      "publishScale": 1.4,
      "publishRounding": "round each drawn dimension × 1.4: 210 × 270 px",
      "window": {
        "x": 7,
        "y": 8,
        "w": 136,
        "h": 144
      },
      "contains": [
        "white paper",
        "own opaque neon-palm scene",
        "baked graphic caption and outlined heart"
      ],
      "excludes": [
        "avatar",
        "live text"
      ],
      "bakedCaption": "SAME ME ♡",
      "generation": "built-in image_gen.imagegen; prompt and native source in work/stage4-generation-prompts.json",
      "registration": {
        "sourceDimensions": [
          1105,
          1423
        ],
        "sourceWindow": {
          "x": 41,
          "y": 34,
          "w": 1025,
          "h": 1022
        },
        "sceneFit": "uniform cover",
        "captionFit": "uniform scale to the reference 41-unit paper band; no retyping or font",
        "frame": "generated paper strips registered to reference 7 side / 8 top / 41 bottom",
        "nativeSourceScale": [
          7.366666666666666,
          7.373056994818653
        ]
      },
      "opaqueRule": "entire paper and photo scene alpha 255; avatar transparency reveals this scene",
      "renderRule": "one uniformly scaled complete plate; no slicing, tinting, additional frame or caption layer"
    },
    "print.3": {
      "path": "art/src/player-card-2026-10-07/pieces/publish/print.3.png",
      "pixelW": 210,
      "pixelH": 270,
      "alpha": true,
      "alphaRange": [
        255,
        255
      ],
      "transparentPixels": 0,
      "partialAlphaPixels": 0,
      "sha256": "857eb2aa6f3d8f76d0a86b8fc1e2ec101802f900cbdb9cbd67fae97c91d39d95",
      "reused": false,
      "master": {
        "path": "art/src/player-card-2026-10-07/pieces/print.3.png",
        "pixelW": 900,
        "pixelH": 1158,
        "scale": 6,
        "sha256": "e559d2853fc4a5f427dd4130beba4086b73c34d8563131d031d80ad620b3c0ae"
      },
      "drawnSize": {
        "w": 150,
        "h": 193
      },
      "publishScale": 1.4,
      "publishRounding": "round each drawn dimension × 1.4: 210 × 270 px",
      "window": {
        "x": 7,
        "y": 8,
        "w": 136,
        "h": 144
      },
      "contains": [
        "white paper",
        "own opaque neon-palm scene",
        "baked graphic caption and outlined heart"
      ],
      "excludes": [
        "avatar",
        "live text"
      ],
      "bakedCaption": "MORE TO DISCOVER ♡",
      "generation": "built-in image_gen.imagegen; prompt and native source in work/stage4-generation-prompts.json",
      "registration": {
        "sourceDimensions": [
          1105,
          1423
        ],
        "sourceWindow": {
          "x": 40,
          "y": 35,
          "w": 1028,
          "h": 1023
        },
        "sceneFit": "uniform cover",
        "captionFit": "uniform scale to the reference 41-unit paper band; no retyping or font",
        "frame": "generated paper strips registered to reference 7 side / 8 top / 41 bottom",
        "nativeSourceScale": [
          7.366666666666666,
          7.373056994818653
        ]
      },
      "opaqueRule": "entire paper and photo scene alpha 255; avatar transparency reveals this scene",
      "renderRule": "one uniformly scaled complete plate; no slicing, tinting, additional frame or caption layer"
    }
  },
  "elements": [
    {
      "id": "title.pill",
      "piece": "pill.large.png",
      "x": 102.225,
      "y": 358.663,
      "w": 739.989,
      "h": 108.674,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 124,
        "bottom": 0,
        "left": 124
      },
      "neonBox": {
        "x": 118,
        "y": 374,
        "w": 708,
        "h": 78
      },
      "filter": "hue-rotate(131deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH"
    },
    {
      "id": "card.base",
      "piece": "card.base.female",
      "x": 44,
      "y": 445,
      "w": 856,
      "h": 1143,
      "render": "border-image",
      "slicePx": {
        "top": 332,
        "right": 126,
        "bottom": 197,
        "left": 126
      },
      "borderWidthStage": {
        "top": 332,
        "right": 126,
        "bottom": 197,
        "left": 126
      },
      "z": 110,
      "neonBox": {
        "x": 67,
        "y": 473,
        "w": 808,
        "h": 1092
      },
      "cornerRule": "all source corners at 1:1 registered scale; only middle strips stretch",
      "masterResolutionRule": "keep this stage box and borderWidthStage fixed; multiply source slicePx/sourceRect by newMasterDimensions/currentMasterDimensions after remeasurement; no layout rescale"
    },
    {
      "id": "crown",
      "render": "in-base",
      "parent": "card.base",
      "x": 226,
      "y": 561,
      "w": 60,
      "h": 53,
      "z": 110
    },
    {
      "id": "big.symbol",
      "render": "in-base",
      "parent": "card.base",
      "x": 722,
      "y": 594,
      "w": 88,
      "h": 136,
      "z": 110
    },
    {
      "id": "print.0",
      "piece": "print.1",
      "x": 525.835,
      "y": 598.67,
      "w": 150,
      "h": 193,
      "render": "print",
      "rotationDegrees": -13.57,
      "transformOrigin": "50% 50%",
      "z": 120,
      "referenceRotatedBox": {
        "x": 506.63,
        "y": 583.28,
        "w": 188.41,
        "h": 223.78
      },
      "referenceCentre": {
        "x": 600.835,
        "y": 695.17
      },
      "window": {
        "x": 7,
        "y": 8,
        "w": 136,
        "h": 144
      },
      "imagePiece": "avatar.female.victory",
      "objectFit": "cover",
      "objectPosition": "50% 0%",
      "imageCrop": {
        "trimTransparentThreshold": 4,
        "topCentreFraction": 0.68
      },
      "layers": [
        {
          "role": "plate",
          "piece": "print.1",
          "z": 0
        },
        {
          "role": "portrait",
          "piece": "avatar.female.victory",
          "z": 1,
          "clip": "window"
        }
      ],
      "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
      "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
      "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
    },
    {
      "id": "print.1",
      "piece": "print.2",
      "x": 635.615,
      "y": 737.465,
      "w": 150,
      "h": 193,
      "render": "print",
      "rotationDegrees": 13.62,
      "transformOrigin": "50% 50%",
      "z": 140,
      "referenceRotatedBox": {
        "x": 620.31,
        "y": 724.82,
        "w": 180.61,
        "h": 218.29
      },
      "referenceCentre": {
        "x": 710.615,
        "y": 833.965
      },
      "window": {
        "x": 7,
        "y": 8,
        "w": 136,
        "h": 144
      },
      "imagePiece": "avatar.female.thinking",
      "objectFit": "cover",
      "objectPosition": "50% 0%",
      "imageCrop": {
        "trimTransparentThreshold": 4,
        "topCentreFraction": 0.68
      },
      "layers": [
        {
          "role": "plate",
          "piece": "print.2",
          "z": 0
        },
        {
          "role": "portrait",
          "piece": "avatar.female.thinking",
          "z": 1,
          "clip": "window"
        }
      ],
      "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
      "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
      "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
    },
    {
      "id": "print.2",
      "piece": "print.3",
      "x": 699.46,
      "y": 845.405,
      "w": 150,
      "h": 193,
      "render": "print",
      "rotationDegrees": -13.93,
      "transformOrigin": "50% 50%",
      "z": 150,
      "referenceRotatedBox": {
        "x": 689.09,
        "y": 845.1,
        "w": 170.74,
        "h": 193.61
      },
      "referenceCentre": {
        "x": 774.46,
        "y": 941.905
      },
      "window": {
        "x": 7,
        "y": 8,
        "w": 136,
        "h": 144
      },
      "imagePiece": "avatar.female.flirt",
      "objectFit": "cover",
      "objectPosition": "50% 0%",
      "imageCrop": {
        "trimTransparentThreshold": 4,
        "topCentreFraction": 0.68
      },
      "layers": [
        {
          "role": "plate",
          "piece": "print.3",
          "z": 0
        },
        {
          "role": "portrait",
          "piece": "avatar.female.flirt",
          "z": 1,
          "clip": "window"
        }
      ],
      "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
      "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
      "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
    },
    {
      "id": "avatar.happy",
      "piece": "avatar.female.happy",
      "x": 223.5,
      "y": 707,
      "w": 495,
      "h": 387,
      "render": "avatar",
      "z": 130,
      "objectFit": "cover",
      "objectPosition": "50% 0%",
      "trimTransparentThreshold": 4,
      "clip": {
        "type": "rect",
        "x": 223.5,
        "y": 707,
        "w": 495,
        "h": 387
      },
      "centredOn": "measured card centre",
      "cropRule": "trim transparent exterior only, uniformly cover measured box, centre horizontally, crop bottom; no stretch"
    },
    {
      "id": "age.divider",
      "render": "css-rule",
      "x": 265,
      "y": 728,
      "w": 3,
      "h": 96,
      "z": 160,
      "css": {
        "background": "rgba(255,255,255,.6)"
      },
      "note": "plain 3-unit separator explicitly allowed by stage-2 brief; not a replacement UI surface"
    },
    {
      "id": "small.symbol",
      "piece": "symbol.female",
      "x": 287,
      "y": 737.184,
      "w": 49,
      "h": 69.632,
      "render": "image",
      "sourceRect": {
        "x": 8,
        "y": 8,
        "w": 76,
        "h": 108
      },
      "z": 170,
      "filter": "hue-rotate(0deg)"
    },
    {
      "id": "flag.reserved",
      "render": "reserved",
      "x": 112,
      "y": 844,
      "w": 64,
      "h": 48,
      "empty": true,
      "z": 160,
      "ownerDecision": "flag asset undecided"
    },
    {
      "id": "tag.0",
      "piece": "create.pill.off",
      "x": 100.233,
      "y": 1047.395,
      "w": 274.047,
      "h": 117.209,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "neonBox": {
        "x": 122,
        "y": 1070,
        "w": 228,
        "h": 72
      },
      "filter": "hue-rotate(98.55deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH",
      "slot": 0,
      "category": "ROLE",
      "referenceHue": 321.55
    },
    {
      "id": "tag.1",
      "piece": "create.pill.off",
      "x": 341.233,
      "y": 1047.395,
      "w": 263.047,
      "h": 117.209,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "neonBox": {
        "x": 363,
        "y": 1070,
        "w": 217,
        "h": 72
      },
      "filter": "hue-rotate(-9.31deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH",
      "slot": 1,
      "category": "EXPERIENCES",
      "referenceHue": 213.69
    },
    {
      "id": "tag.2",
      "piece": "create.pill.off",
      "x": 572.233,
      "y": 1047.395,
      "w": 272.047,
      "h": 117.209,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "neonBox": {
        "x": 594,
        "y": 1070,
        "w": 226,
        "h": 72
      },
      "filter": "hue-rotate(-193.14deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH",
      "slot": 2,
      "category": "MONEY",
      "referenceHue": 29.86
    },
    {
      "id": "tag.3",
      "piece": "create.pill.off",
      "x": 100.233,
      "y": 1132.395,
      "w": 273.047,
      "h": 117.209,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "neonBox": {
        "x": 122,
        "y": 1155,
        "w": 227,
        "h": 72
      },
      "filter": "hue-rotate(97.88deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH",
      "slot": 3,
      "category": "TALK",
      "referenceHue": 320.88
    },
    {
      "id": "tag.4",
      "piece": "create.pill.off",
      "x": 341.233,
      "y": 1131.395,
      "w": 264.047,
      "h": 117.209,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "neonBox": {
        "x": 363,
        "y": 1154,
        "w": 218,
        "h": 72
      },
      "filter": "hue-rotate(44.91deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH",
      "slot": 4,
      "category": "SHARING",
      "referenceHue": 267.91
    },
    {
      "id": "tag.5",
      "piece": "create.pill.off",
      "x": 573.233,
      "y": 1132.395,
      "w": 271.047,
      "h": 117.209,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 84,
        "bottom": 0,
        "left": 84
      },
      "neonBox": {
        "x": 595,
        "y": 1155,
        "w": 225,
        "h": 72
      },
      "filter": "hue-rotate(-62.38deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH",
      "slot": 5,
      "category": "TEMPO",
      "referenceHue": 160.62
    },
    {
      "id": "bio.pill",
      "piece": "pill.large.png",
      "x": 109.978,
      "y": 1241.534,
      "w": 720.601,
      "h": 137.933,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 124,
        "bottom": 0,
        "left": 124
      },
      "neonBox": {
        "x": 130,
        "y": 1261,
        "w": 680,
        "h": 99
      },
      "filter": "hue-rotate(131deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH"
    },
    {
      "id": "quote.0",
      "piece": "quote.open",
      "x": 155,
      "y": 1283.896,
      "w": 52,
      "h": 38.209,
      "render": "image",
      "sourceRect": {
        "x": 17,
        "y": 18,
        "w": 230,
        "h": 169
      },
      "z": 170,
      "color": "#ff3cdd"
    },
    {
      "id": "quote.1",
      "piece": "quote.close",
      "x": 732,
      "y": 1285.868,
      "w": 54,
      "h": 40.263,
      "render": "image",
      "sourceRect": {
        "x": 17,
        "y": 16,
        "w": 228,
        "h": 170
      },
      "z": 170,
      "color": "#ff3cdd"
    },
    {
      "id": "send.plate",
      "piece": "cta.plate.png",
      "x": 252,
      "y": 1381.86,
      "w": 435,
      "h": 126.28,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 331,
        "bottom": 0,
        "left": 331
      },
      "filter": "none",
      "z": 160,
      "capRule": "126.28 * 331 / 326 = 128.2155828221; Crew CSS rounds to 128.2",
      "source": "CrewSheet.tsx + app.css .mc-send"
    },
    {
      "id": "send.icon",
      "piece": "icon.paper-plane",
      "render": "image",
      "x": 311,
      "y": 1419,
      "w": 64,
      "h": 56,
      "z": 170,
      "filter": "brightness(0)",
      "visible": false,
      "reason": "optional icon omitted: fixed 56 word plus plane and gap exceeds reference width",
      "wordShift": 0
    },
    {
      "id": "close",
      "piece": "close",
      "x": 779.206,
      "y": 503,
      "w": 71.588,
      "h": 69,
      "render": "image",
      "sourceRect": {
        "x": 33,
        "y": 38,
        "w": 166,
        "h": 160
      },
      "z": 170
    },
    {
      "id": "timer.pill",
      "piece": "pill.large.png",
      "x": 148.843,
      "y": 1569.236,
      "w": 642.708,
      "h": 97.528,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 124,
        "bottom": 0,
        "left": 124
      },
      "neonBox": {
        "x": 163,
        "y": 1583,
        "w": 614,
        "h": 70
      },
      "filter": "hue-rotate(131deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH"
    },
    {
      "id": "timer.clock",
      "piece": "icon.clock",
      "x": 193,
      "y": 1597,
      "w": 41,
      "h": 41,
      "render": "image",
      "sourceRect": {
        "x": 5,
        "y": 5,
        "w": 70,
        "h": 70
      },
      "z": 170
    },
    {
      "id": "timer.track",
      "piece": "pill.large.png",
      "x": 257.742,
      "y": 1598.888,
      "w": 422.663,
      "h": 36.225,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 124,
        "bottom": 0,
        "left": 124
      },
      "neonBox": {
        "x": 263,
        "y": 1604,
        "w": 412,
        "h": 26
      },
      "filter": "hue-rotate(131deg) brightness(0.48)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH"
    },
    {
      "id": "timer.fill",
      "piece": "cta.plate.png",
      "x": 258.996,
      "y": 1602.275,
      "w": 420.008,
      "h": 30.356,
      "render": "3-slice",
      "slicePx": {
        "top": 0,
        "right": 331,
        "bottom": 0,
        "left": 331
      },
      "neonBox": {
        "x": 263,
        "y": 1606,
        "w": 412,
        "h": 23
      },
      "filter": "hue-rotate(275deg)",
      "z": 150,
      "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
      "capRule": "h * slicePx.left / source pixelH",
      "clipRule": {
        "type": "inset",
        "right": "(1 - clamp(remainingMs / durationMs,0,1)) * 100%",
        "referenceFraction": 0.379,
        "referenceFillBox": {
          "x": 263,
          "y": 1606,
          "w": 156,
          "h": 23
        },
        "zero": "hide",
        "note": "full-width 3-slice rendered once; clip reveals left fraction; never squeeze either cap. Right clipping edge is straight and differs from reference."
      }
    }
  ],
  "texts": [
    {
      "id": "title",
      "text": "WHAT WOULD SAMANTHA ANSWER?",
      "role": "title",
      "font": "Nunito",
      "weight": 800,
      "size": 26.25,
      "trackingEm": 0,
      "x": 182,
      "y": 402,
      "w": 580,
      "h": 45,
      "lineHeight": 45,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 21,
      "proofInkTop": 402,
      "proofInkAlign": "center",
      "textTransform": "uppercase",
      "displayText": "WHAT WOULD SAMANTHA ANSWER?",
      "binding": "player.displayName",
      "spans": [
        {
          "text": "WHAT WOULD "
        },
        {
          "text": "SAMANTHA",
          "color": "#ff3cdd",
          "binding": "player.displayName"
        },
        {
          "text": " ANSWER?"
        }
      ],
      "measured": {
        "advance": 493.636,
        "inkW": 493,
        "inkH": 20,
        "baselineOffset": 19,
        "missingGlyphs": []
      },
      "initialSize": 28.75,
      "familyReduction": 0.913
    },
    {
      "id": "name",
      "text": "Samantha",
      "role": "name",
      "font": "Nunito",
      "weight": 900,
      "size": 102.5,
      "trackingEm": 0,
      "x": 112,
      "y": 610,
      "w": 374,
      "h": 76,
      "lineHeight": 76,
      "align": "left",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 75,
      "proofInkTop": 610,
      "proofInkAlign": "left",
      "gradient": [
        "#ffffff",
        "#ff3cdd"
      ],
      "binding": "player.displayName",
      "overflow": "ellipsis",
      "proposal": true,
      "measured": {
        "advance": 503.48,
        "inkW": 495,
        "inkH": 75,
        "baselineOffset": 73.5,
        "missingGlyphs": []
      },
      "proposalDisplay": "Sama…"
    },
    {
      "id": "age",
      "text": "23",
      "role": "age",
      "font": "Nunito",
      "weight": 900,
      "size": 118.25,
      "trackingEm": 0,
      "x": 114,
      "y": 728,
      "w": 134,
      "h": 95,
      "lineHeight": 95,
      "align": "left",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 93,
      "proofInkTop": 728,
      "proofInkAlign": "left",
      "binding": "player.age",
      "measured": {
        "advance": 141.6,
        "inkW": 132,
        "inkH": 87,
        "baselineOffset": 85,
        "missingGlyphs": []
      },
      "initialSize": 128.75,
      "familyReduction": 0.918
    },
    {
      "id": "country",
      "text": "Spain",
      "role": "country",
      "font": "Nunito",
      "weight": 800,
      "size": 35.25,
      "trackingEm": 0,
      "x": 195,
      "y": 858,
      "w": 93,
      "h": 36,
      "lineHeight": 36,
      "align": "left",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 28,
      "proofInkTop": 858,
      "proofInkAlign": "left",
      "binding": "player.country",
      "measured": {
        "advance": 93.485,
        "inkW": 90,
        "inkH": 33,
        "baselineOffset": 26,
        "missingGlyphs": []
      },
      "initialSize": 38.5,
      "familyReduction": 0.916
    },
    {
      "id": "city",
      "text": "Madrid",
      "role": "city",
      "font": "Nunito",
      "weight": 700,
      "size": 26.5,
      "trackingEm": 0,
      "x": 159,
      "y": 919,
      "w": 87,
      "h": 22,
      "lineHeight": 22,
      "align": "left",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 20,
      "proofInkTop": 919,
      "proofInkAlign": "left",
      "binding": "player.city",
      "emptyBehavior": "blank; no movement",
      "pin": false,
      "measured": {
        "advance": 86.443,
        "inkW": 83,
        "inkH": 20,
        "baselineOffset": 19.5,
        "missingGlyphs": []
      },
      "initialSize": 28.75,
      "familyReduction": 0.922
    },
    {
      "id": "tag.0.word",
      "text": "Sociable",
      "role": "tag",
      "font": "Nunito",
      "weight": 700,
      "size": 26.25,
      "trackingEm": 0,
      "x": 154,
      "y": 1070,
      "w": 164,
      "h": 72,
      "lineHeight": 72,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 21,
      "proofInkTop": 1070,
      "proofInkAlign": "center",
      "proofInkCentreY": 1106,
      "binding": "player.tags[0]",
      "nullBehavior": "word empty; pill retained; proposal",
      "measured": {
        "advance": 102.362,
        "inkW": 101,
        "inkH": 20,
        "baselineOffset": 19,
        "missingGlyphs": []
      }
    },
    {
      "id": "tag.1.word",
      "text": "Curious",
      "role": "tag",
      "font": "Nunito",
      "weight": 700,
      "size": 26.25,
      "trackingEm": 0,
      "x": 395,
      "y": 1070,
      "w": 153,
      "h": 72,
      "lineHeight": 72,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 21,
      "proofInkTop": 1070,
      "proofInkAlign": "center",
      "proofInkCentreY": 1106,
      "binding": "player.tags[1]",
      "nullBehavior": "word empty; pill retained; proposal",
      "measured": {
        "advance": 91.936,
        "inkW": 90,
        "inkH": 20,
        "baselineOffset": 19,
        "missingGlyphs": []
      }
    },
    {
      "id": "tag.2.word",
      "text": "Generous",
      "role": "tag",
      "font": "Nunito",
      "weight": 700,
      "size": 26.25,
      "trackingEm": 0,
      "x": 626,
      "y": 1070,
      "w": 162,
      "h": 72,
      "lineHeight": 72,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 21,
      "proofInkTop": 1070,
      "proofInkAlign": "center",
      "proofInkCentreY": 1106,
      "binding": "player.tags[2]",
      "nullBehavior": "word empty; pill retained; proposal",
      "measured": {
        "advance": 115.232,
        "inkW": 114,
        "inkH": 20,
        "baselineOffset": 19,
        "missingGlyphs": []
      }
    },
    {
      "id": "tag.3.word",
      "text": "Playful",
      "role": "tag",
      "font": "Nunito",
      "weight": 700,
      "size": 26.25,
      "trackingEm": 0,
      "x": 154,
      "y": 1155,
      "w": 163,
      "h": 72,
      "lineHeight": 72,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 21,
      "proofInkTop": 1155,
      "proofInkAlign": "center",
      "proofInkCentreY": 1191,
      "binding": "player.tags[3]",
      "nullBehavior": "word empty; pill retained; proposal",
      "measured": {
        "advance": 86.034,
        "inkW": 84,
        "inkH": 24,
        "baselineOffset": 19,
        "missingGlyphs": []
      }
    },
    {
      "id": "tag.4.word",
      "text": "Selective",
      "role": "tag",
      "font": "Nunito",
      "weight": 700,
      "size": 26.25,
      "trackingEm": 0,
      "x": 395,
      "y": 1154,
      "w": 154,
      "h": 72,
      "lineHeight": 72,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 21,
      "proofInkTop": 1154,
      "proofInkAlign": "center",
      "proofInkCentreY": 1190,
      "binding": "player.tags[4]",
      "nullBehavior": "word empty; pill retained; proposal",
      "measured": {
        "advance": 109.564,
        "inkW": 108,
        "inkH": 20,
        "baselineOffset": 19,
        "missingGlyphs": []
      }
    },
    {
      "id": "tag.5.word",
      "text": "Spontaneous",
      "role": "tag",
      "font": "Nunito",
      "weight": 700,
      "size": 26.25,
      "trackingEm": 0,
      "x": 627,
      "y": 1155,
      "w": 161,
      "h": 72,
      "lineHeight": 72,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 21,
      "proofInkTop": 1155,
      "proofInkAlign": "center",
      "proofInkCentreY": 1191,
      "binding": "player.tags[5]",
      "nullBehavior": "word empty; pill retained; proposal",
      "measured": {
        "advance": 158.418,
        "inkW": 157,
        "inkH": 24,
        "baselineOffset": 19,
        "missingGlyphs": []
      }
    },
    {
      "id": "bio.0",
      "text": "Chaos, chemistry, and late-night laughs.",
      "role": "bio",
      "font": "Nunito",
      "weight": 600,
      "size": 23.5,
      "trackingEm": 0,
      "x": 222,
      "y": 1286,
      "w": 496,
      "h": 32,
      "lineHeight": 32,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 19,
      "proofInkTop": 1286,
      "proofInkAlign": "center",
      "binding": "player.bio",
      "line": 0,
      "maxLines": 2,
      "linePitch": 32,
      "emptyBehavior": "hide words and quotes; keep capsule and every box fixed",
      "measured": {
        "advance": 430.215,
        "inkW": 428,
        "inkH": 22,
        "baselineOffset": 17,
        "missingGlyphs": []
      }
    },
    {
      "id": "bio.1",
      "text": "I love deep talks and even deeper connections.",
      "role": "bio",
      "font": "Nunito",
      "weight": 600,
      "size": 23.5,
      "trackingEm": 0,
      "x": 222,
      "y": 1318,
      "w": 496,
      "h": 32,
      "lineHeight": 32,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 18,
      "proofInkTop": 1318,
      "proofInkAlign": "center",
      "binding": "player.bio",
      "line": 1,
      "maxLines": 2,
      "linePitch": 32,
      "emptyBehavior": "hide words and quotes; keep capsule and every box fixed",
      "measured": {
        "advance": 497.096,
        "inkW": 495,
        "inkH": 22,
        "baselineOffset": 17,
        "missingGlyphs": []
      }
    },
    {
      "id": "send.label",
      "text": "Send Message",
      "role": "send",
      "font": "Nunito",
      "weight": 800,
      "size": 56,
      "trackingEm": 0.01,
      "x": 252,
      "y": 1381.86,
      "w": 435,
      "h": 126.28,
      "lineHeight": 56,
      "align": "center",
      "color": "#000000",
      "z": 180,
      "referenceCap": 26,
      "proofInkTop": 1381.86,
      "proofInkAlign": "center",
      "proofInkCentreY": 1445,
      "wordShift": 0,
      "measured": {
        "advance": 387.184,
        "inkW": 384,
        "inkH": 52,
        "baselineOffset": 40.5,
        "missingGlyphs": []
      }
    },
    {
      "id": "timer.digits",
      "text": "5s",
      "role": "timer",
      "font": "Nunito",
      "weight": 900,
      "size": 25.25,
      "trackingEm": 0,
      "x": 689,
      "y": 1605,
      "w": 64,
      "h": 40,
      "lineHeight": 40,
      "align": "center",
      "color": "#ffffff",
      "z": 180,
      "referenceCap": 26,
      "proofInkTop": 1605,
      "proofInkAlign": "center",
      "proofInkCentreY": 1618,
      "binding": "ceil(remainingMs/1000) + \"s\"",
      "overflow": "visible",
      "numericVariant": "tabular-nums",
      "referenceSizeRule": "one timer family reduced if 120s, the protocol maximum, consumes the digits lane",
      "measured": {
        "advance": 27.4,
        "inkW": 26,
        "inkH": 19,
        "baselineOffset": 18,
        "missingGlyphs": []
      },
      "initialSize": 36.75,
      "familyReduction": 0.687
    }
  ],
  "hitTargets": [
    {
      "id": "close",
      "x": 757,
      "y": 479.5,
      "w": 116,
      "h": 116,
      "action": "close-card",
      "enabled": true,
      "z": 230,
      "stopPropagation": true,
      "ariaLabel": "Close player card"
    },
    {
      "id": "send",
      "x": 252,
      "y": 1381.86,
      "w": 435,
      "h": 126.28,
      "action": "open-player-message",
      "enabled": true,
      "z": 230,
      "stopPropagation": true,
      "disabledBehavior": "consume tap; never bubble to close-card",
      "ariaLabel": "Send Message"
    },
    {
      "id": "card.body",
      "x": 67,
      "y": 473,
      "w": 808,
      "h": 1092,
      "action": "close-card",
      "enabled": true,
      "z": 200,
      "exclude": [
        "close",
        "send"
      ],
      "note": "art/text children do not intercept; own invisible catcher under controls"
    },
    {
      "id": "backdrop",
      "x": 0,
      "y": 0,
      "w": 941,
      "h": 1672,
      "action": "close-card",
      "enabled": true,
      "z": 101,
      "exclude": [
        "roster",
        "card.body",
        "close",
        "send"
      ],
      "note": "roster hit areas have precedence and stop propagation"
    },
    {
      "id": "roster",
      "inherit": "existing GameRoster seat buttons",
      "band": {
        "x": 0,
        "y": 284,
        "w": 941,
        "h": 175
      },
      "enabled": true,
      "z": 240,
      "action": "existing player-card action",
      "stopPropagation": true,
      "doNotMove": true
    }
  ],
  "themes": {
    "female": {
      "basePiece": "card.base.female",
      "color": "#ff3cdd",
      "hue": 318,
      "smallSymbolPiece": "symbol.female",
      "largeSymbol": "in card base",
      "crown": "in card base",
      "avatarId": "snw-cast-0001",
      "elements": [
        {
          "id": "title.pill",
          "piece": "pill.large.png",
          "x": 102.225,
          "y": 358.663,
          "w": 739.989,
          "h": 108.674,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 118,
            "y": 374,
            "w": 708,
            "h": 78
          },
          "filter": "hue-rotate(131deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "card.base",
          "piece": "card.base.female",
          "x": 44,
          "y": 445,
          "w": 856,
          "h": 1143,
          "render": "border-image",
          "slicePx": {
            "top": 332,
            "right": 126,
            "bottom": 197,
            "left": 126
          },
          "borderWidthStage": {
            "top": 332,
            "right": 126,
            "bottom": 197,
            "left": 126
          },
          "z": 110,
          "neonBox": {
            "x": 67,
            "y": 473,
            "w": 808,
            "h": 1092
          },
          "cornerRule": "all source corners at 1:1 registered scale; only middle strips stretch",
          "masterResolutionRule": "keep this stage box and borderWidthStage fixed; multiply source slicePx/sourceRect by newMasterDimensions/currentMasterDimensions after remeasurement; no layout rescale"
        },
        {
          "id": "crown",
          "render": "in-base",
          "parent": "card.base",
          "x": 226,
          "y": 561,
          "w": 60,
          "h": 53,
          "z": 110
        },
        {
          "id": "big.symbol",
          "render": "in-base",
          "parent": "card.base",
          "x": 722,
          "y": 594,
          "w": 88,
          "h": 136,
          "z": 110
        },
        {
          "id": "print.0",
          "piece": "print.1",
          "x": 525.835,
          "y": 598.67,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": -13.57,
          "transformOrigin": "50% 50%",
          "z": 120,
          "referenceRotatedBox": {
            "x": 506.63,
            "y": 583.28,
            "w": 188.41,
            "h": 223.78
          },
          "referenceCentre": {
            "x": 600.835,
            "y": 695.17
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.female.victory",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.1",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.female.victory",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "print.1",
          "piece": "print.2",
          "x": 635.615,
          "y": 737.465,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": 13.62,
          "transformOrigin": "50% 50%",
          "z": 140,
          "referenceRotatedBox": {
            "x": 620.31,
            "y": 724.82,
            "w": 180.61,
            "h": 218.29
          },
          "referenceCentre": {
            "x": 710.615,
            "y": 833.965
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.female.thinking",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.2",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.female.thinking",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "print.2",
          "piece": "print.3",
          "x": 699.46,
          "y": 845.405,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": -13.93,
          "transformOrigin": "50% 50%",
          "z": 150,
          "referenceRotatedBox": {
            "x": 689.09,
            "y": 845.1,
            "w": 170.74,
            "h": 193.61
          },
          "referenceCentre": {
            "x": 774.46,
            "y": 941.905
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.female.flirt",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.3",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.female.flirt",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "avatar.happy",
          "piece": "avatar.female.happy",
          "x": 223.5,
          "y": 707,
          "w": 495,
          "h": 387,
          "render": "avatar",
          "z": 130,
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "trimTransparentThreshold": 4,
          "clip": {
            "type": "rect",
            "x": 223.5,
            "y": 707,
            "w": 495,
            "h": 387
          },
          "centredOn": "measured card centre",
          "cropRule": "trim transparent exterior only, uniformly cover measured box, centre horizontally, crop bottom; no stretch"
        },
        {
          "id": "age.divider",
          "render": "css-rule",
          "x": 265,
          "y": 728,
          "w": 3,
          "h": 96,
          "z": 160,
          "css": {
            "background": "rgba(255,255,255,.6)"
          },
          "note": "plain 3-unit separator explicitly allowed by stage-2 brief; not a replacement UI surface"
        },
        {
          "id": "small.symbol",
          "piece": "symbol.female",
          "x": 287,
          "y": 737.184,
          "w": 49,
          "h": 69.632,
          "render": "image",
          "sourceRect": {
            "x": 8,
            "y": 8,
            "w": 76,
            "h": 108
          },
          "z": 170,
          "filter": "hue-rotate(0deg)"
        },
        {
          "id": "flag.reserved",
          "render": "reserved",
          "x": 112,
          "y": 844,
          "w": 64,
          "h": 48,
          "empty": true,
          "z": 160,
          "ownerDecision": "flag asset undecided"
        },
        {
          "id": "tag.0",
          "piece": "create.pill.off",
          "x": 100.233,
          "y": 1047.395,
          "w": 274.047,
          "h": 117.209,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 122,
            "y": 1070,
            "w": 228,
            "h": 72
          },
          "filter": "hue-rotate(98.55deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 0,
          "category": "ROLE",
          "referenceHue": 321.55
        },
        {
          "id": "tag.1",
          "piece": "create.pill.off",
          "x": 341.233,
          "y": 1047.395,
          "w": 263.047,
          "h": 117.209,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 363,
            "y": 1070,
            "w": 217,
            "h": 72
          },
          "filter": "hue-rotate(-9.31deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 1,
          "category": "EXPERIENCES",
          "referenceHue": 213.69
        },
        {
          "id": "tag.2",
          "piece": "create.pill.off",
          "x": 572.233,
          "y": 1047.395,
          "w": 272.047,
          "h": 117.209,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 594,
            "y": 1070,
            "w": 226,
            "h": 72
          },
          "filter": "hue-rotate(-193.14deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 2,
          "category": "MONEY",
          "referenceHue": 29.86
        },
        {
          "id": "tag.3",
          "piece": "create.pill.off",
          "x": 100.233,
          "y": 1132.395,
          "w": 273.047,
          "h": 117.209,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 122,
            "y": 1155,
            "w": 227,
            "h": 72
          },
          "filter": "hue-rotate(97.88deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 3,
          "category": "TALK",
          "referenceHue": 320.88
        },
        {
          "id": "tag.4",
          "piece": "create.pill.off",
          "x": 341.233,
          "y": 1131.395,
          "w": 264.047,
          "h": 117.209,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 363,
            "y": 1154,
            "w": 218,
            "h": 72
          },
          "filter": "hue-rotate(44.91deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 4,
          "category": "SHARING",
          "referenceHue": 267.91
        },
        {
          "id": "tag.5",
          "piece": "create.pill.off",
          "x": 573.233,
          "y": 1132.395,
          "w": 271.047,
          "h": 117.209,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 595,
            "y": 1155,
            "w": 225,
            "h": 72
          },
          "filter": "hue-rotate(-62.38deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 5,
          "category": "TEMPO",
          "referenceHue": 160.62
        },
        {
          "id": "bio.pill",
          "piece": "pill.large.png",
          "x": 109.978,
          "y": 1241.534,
          "w": 720.601,
          "h": 137.933,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 130,
            "y": 1261,
            "w": 680,
            "h": 99
          },
          "filter": "hue-rotate(131deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "quote.0",
          "piece": "quote.open",
          "x": 155,
          "y": 1283.896,
          "w": 52,
          "h": 38.209,
          "render": "image",
          "sourceRect": {
            "x": 17,
            "y": 18,
            "w": 230,
            "h": 169
          },
          "z": 170,
          "color": "#ff3cdd"
        },
        {
          "id": "quote.1",
          "piece": "quote.close",
          "x": 732,
          "y": 1285.868,
          "w": 54,
          "h": 40.263,
          "render": "image",
          "sourceRect": {
            "x": 17,
            "y": 16,
            "w": 228,
            "h": 170
          },
          "z": 170,
          "color": "#ff3cdd"
        },
        {
          "id": "send.plate",
          "piece": "cta.plate.png",
          "x": 252,
          "y": 1381.86,
          "w": 435,
          "h": 126.28,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 331,
            "bottom": 0,
            "left": 331
          },
          "filter": "none",
          "z": 160,
          "capRule": "126.28 * 331 / 326 = 128.2155828221; Crew CSS rounds to 128.2",
          "source": "CrewSheet.tsx + app.css .mc-send"
        },
        {
          "id": "send.icon",
          "piece": "icon.paper-plane",
          "render": "image",
          "x": 311,
          "y": 1419,
          "w": 64,
          "h": 56,
          "z": 170,
          "filter": "brightness(0)",
          "visible": false,
          "reason": "optional icon omitted: fixed 56 word plus plane and gap exceeds reference width",
          "wordShift": 0
        },
        {
          "id": "close",
          "piece": "close",
          "x": 779.206,
          "y": 503,
          "w": 71.588,
          "h": 69,
          "render": "image",
          "sourceRect": {
            "x": 33,
            "y": 38,
            "w": 166,
            "h": 160
          },
          "z": 170
        },
        {
          "id": "timer.pill",
          "piece": "pill.large.png",
          "x": 148.843,
          "y": 1569.236,
          "w": 642.708,
          "h": 97.528,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 163,
            "y": 1583,
            "w": 614,
            "h": 70
          },
          "filter": "hue-rotate(131deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "timer.clock",
          "piece": "icon.clock",
          "x": 193,
          "y": 1597,
          "w": 41,
          "h": 41,
          "render": "image",
          "sourceRect": {
            "x": 5,
            "y": 5,
            "w": 70,
            "h": 70
          },
          "z": 170
        },
        {
          "id": "timer.track",
          "piece": "pill.large.png",
          "x": 257.742,
          "y": 1598.888,
          "w": 422.663,
          "h": 36.225,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 263,
            "y": 1604,
            "w": 412,
            "h": 26
          },
          "filter": "hue-rotate(131deg) brightness(0.48)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "timer.fill",
          "piece": "cta.plate.png",
          "x": 258.996,
          "y": 1602.275,
          "w": 420.008,
          "h": 30.356,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 331,
            "bottom": 0,
            "left": 331
          },
          "neonBox": {
            "x": 263,
            "y": 1606,
            "w": 412,
            "h": 23
          },
          "filter": "hue-rotate(275deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "clipRule": {
            "type": "inset",
            "right": "(1 - clamp(remainingMs / durationMs,0,1)) * 100%",
            "referenceFraction": 0.379,
            "referenceFillBox": {
              "x": 263,
              "y": 1606,
              "w": 156,
              "h": 23
            },
            "zero": "hide",
            "note": "full-width 3-slice rendered once; clip reveals left fraction; never squeeze either cap. Right clipping edge is straight and differs from reference."
          }
        }
      ],
      "texts": [
        {
          "id": "title",
          "text": "WHAT WOULD SAMANTHA ANSWER?",
          "role": "title",
          "font": "Nunito",
          "weight": 800,
          "size": 26.25,
          "trackingEm": 0,
          "x": 182,
          "y": 402,
          "w": 580,
          "h": 45,
          "lineHeight": 45,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 402,
          "proofInkAlign": "center",
          "textTransform": "uppercase",
          "displayText": "WHAT WOULD SAMANTHA ANSWER?",
          "binding": "player.displayName",
          "spans": [
            {
              "text": "WHAT WOULD "
            },
            {
              "text": "SAMANTHA",
              "color": "#ff3cdd",
              "binding": "player.displayName"
            },
            {
              "text": " ANSWER?"
            }
          ],
          "measured": {
            "advance": 493.636,
            "inkW": 493,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          },
          "initialSize": 28.75,
          "familyReduction": 0.913
        },
        {
          "id": "name",
          "text": "Samantha",
          "role": "name",
          "font": "Nunito",
          "weight": 900,
          "size": 102.5,
          "trackingEm": 0,
          "x": 112,
          "y": 610,
          "w": 374,
          "h": 76,
          "lineHeight": 76,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 75,
          "proofInkTop": 610,
          "proofInkAlign": "left",
          "gradient": [
            "#ffffff",
            "#ff3cdd"
          ],
          "binding": "player.displayName",
          "overflow": "ellipsis",
          "proposal": true,
          "measured": {
            "advance": 503.48,
            "inkW": 495,
            "inkH": 75,
            "baselineOffset": 73.5,
            "missingGlyphs": []
          },
          "proposalDisplay": "Sama…"
        },
        {
          "id": "age",
          "text": "23",
          "role": "age",
          "font": "Nunito",
          "weight": 900,
          "size": 118.25,
          "trackingEm": 0,
          "x": 114,
          "y": 728,
          "w": 134,
          "h": 95,
          "lineHeight": 95,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 93,
          "proofInkTop": 728,
          "proofInkAlign": "left",
          "binding": "player.age",
          "measured": {
            "advance": 141.6,
            "inkW": 132,
            "inkH": 87,
            "baselineOffset": 85,
            "missingGlyphs": []
          },
          "initialSize": 128.75,
          "familyReduction": 0.918
        },
        {
          "id": "country",
          "text": "Spain",
          "role": "country",
          "font": "Nunito",
          "weight": 800,
          "size": 35.25,
          "trackingEm": 0,
          "x": 195,
          "y": 858,
          "w": 93,
          "h": 36,
          "lineHeight": 36,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 28,
          "proofInkTop": 858,
          "proofInkAlign": "left",
          "binding": "player.country",
          "measured": {
            "advance": 93.485,
            "inkW": 90,
            "inkH": 33,
            "baselineOffset": 26,
            "missingGlyphs": []
          },
          "initialSize": 38.5,
          "familyReduction": 0.916
        },
        {
          "id": "city",
          "text": "Madrid",
          "role": "city",
          "font": "Nunito",
          "weight": 700,
          "size": 26.5,
          "trackingEm": 0,
          "x": 159,
          "y": 919,
          "w": 87,
          "h": 22,
          "lineHeight": 22,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 919,
          "proofInkAlign": "left",
          "binding": "player.city",
          "emptyBehavior": "blank; no movement",
          "pin": false,
          "measured": {
            "advance": 86.443,
            "inkW": 83,
            "inkH": 20,
            "baselineOffset": 19.5,
            "missingGlyphs": []
          },
          "initialSize": 28.75,
          "familyReduction": 0.922
        },
        {
          "id": "tag.0.word",
          "text": "Sociable",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 154,
          "y": 1070,
          "w": 164,
          "h": 72,
          "lineHeight": 72,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1070,
          "proofInkAlign": "center",
          "proofInkCentreY": 1106,
          "binding": "player.tags[0]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 102.362,
            "inkW": 101,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.1.word",
          "text": "Curious",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 395,
          "y": 1070,
          "w": 153,
          "h": 72,
          "lineHeight": 72,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1070,
          "proofInkAlign": "center",
          "proofInkCentreY": 1106,
          "binding": "player.tags[1]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 91.936,
            "inkW": 90,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.2.word",
          "text": "Generous",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 626,
          "y": 1070,
          "w": 162,
          "h": 72,
          "lineHeight": 72,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1070,
          "proofInkAlign": "center",
          "proofInkCentreY": 1106,
          "binding": "player.tags[2]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 115.232,
            "inkW": 114,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.3.word",
          "text": "Playful",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 154,
          "y": 1155,
          "w": 163,
          "h": 72,
          "lineHeight": 72,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1155,
          "proofInkAlign": "center",
          "proofInkCentreY": 1191,
          "binding": "player.tags[3]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 86.034,
            "inkW": 84,
            "inkH": 24,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.4.word",
          "text": "Selective",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 395,
          "y": 1154,
          "w": 154,
          "h": 72,
          "lineHeight": 72,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1154,
          "proofInkAlign": "center",
          "proofInkCentreY": 1190,
          "binding": "player.tags[4]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 109.564,
            "inkW": 108,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.5.word",
          "text": "Spontaneous",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 627,
          "y": 1155,
          "w": 161,
          "h": 72,
          "lineHeight": 72,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1155,
          "proofInkAlign": "center",
          "proofInkCentreY": 1191,
          "binding": "player.tags[5]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 158.418,
            "inkW": 157,
            "inkH": 24,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "bio.0",
          "text": "Chaos, chemistry, and late-night laughs.",
          "role": "bio",
          "font": "Nunito",
          "weight": 600,
          "size": 23.5,
          "trackingEm": 0,
          "x": 222,
          "y": 1286,
          "w": 496,
          "h": 32,
          "lineHeight": 32,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 19,
          "proofInkTop": 1286,
          "proofInkAlign": "center",
          "binding": "player.bio",
          "line": 0,
          "maxLines": 2,
          "linePitch": 32,
          "emptyBehavior": "hide words and quotes; keep capsule and every box fixed",
          "measured": {
            "advance": 430.215,
            "inkW": 428,
            "inkH": 22,
            "baselineOffset": 17,
            "missingGlyphs": []
          }
        },
        {
          "id": "bio.1",
          "text": "I love deep talks and even deeper connections.",
          "role": "bio",
          "font": "Nunito",
          "weight": 600,
          "size": 23.5,
          "trackingEm": 0,
          "x": 222,
          "y": 1318,
          "w": 496,
          "h": 32,
          "lineHeight": 32,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 18,
          "proofInkTop": 1318,
          "proofInkAlign": "center",
          "binding": "player.bio",
          "line": 1,
          "maxLines": 2,
          "linePitch": 32,
          "emptyBehavior": "hide words and quotes; keep capsule and every box fixed",
          "measured": {
            "advance": 497.096,
            "inkW": 495,
            "inkH": 22,
            "baselineOffset": 17,
            "missingGlyphs": []
          }
        },
        {
          "id": "send.label",
          "text": "Send Message",
          "role": "send",
          "font": "Nunito",
          "weight": 800,
          "size": 56,
          "trackingEm": 0.01,
          "x": 252,
          "y": 1381.86,
          "w": 435,
          "h": 126.28,
          "lineHeight": 56,
          "align": "center",
          "color": "#000000",
          "z": 180,
          "referenceCap": 26,
          "proofInkTop": 1381.86,
          "proofInkAlign": "center",
          "proofInkCentreY": 1445,
          "wordShift": 0,
          "measured": {
            "advance": 387.184,
            "inkW": 384,
            "inkH": 52,
            "baselineOffset": 40.5,
            "missingGlyphs": []
          }
        },
        {
          "id": "timer.digits",
          "text": "5s",
          "role": "timer",
          "font": "Nunito",
          "weight": 900,
          "size": 25.25,
          "trackingEm": 0,
          "x": 689,
          "y": 1605,
          "w": 64,
          "h": 40,
          "lineHeight": 40,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 26,
          "proofInkTop": 1605,
          "proofInkAlign": "center",
          "proofInkCentreY": 1618,
          "binding": "ceil(remainingMs/1000) + \"s\"",
          "overflow": "visible",
          "numericVariant": "tabular-nums",
          "referenceSizeRule": "one timer family reduced if 120s, the protocol maximum, consumes the digits lane",
          "measured": {
            "advance": 27.4,
            "inkW": 26,
            "inkH": 19,
            "baselineOffset": 18,
            "missingGlyphs": []
          },
          "initialSize": 36.75,
          "familyReduction": 0.687
        }
      ],
      "hitTargets": [
        {
          "id": "close",
          "x": 757,
          "y": 479.5,
          "w": 116,
          "h": 116,
          "action": "close-card",
          "enabled": true,
          "z": 230,
          "stopPropagation": true,
          "ariaLabel": "Close player card"
        },
        {
          "id": "send",
          "x": 252,
          "y": 1381.86,
          "w": 435,
          "h": 126.28,
          "action": "open-player-message",
          "enabled": true,
          "z": 230,
          "stopPropagation": true,
          "disabledBehavior": "consume tap; never bubble to close-card",
          "ariaLabel": "Send Message"
        },
        {
          "id": "card.body",
          "x": 67,
          "y": 473,
          "w": 808,
          "h": 1092,
          "action": "close-card",
          "enabled": true,
          "z": 200,
          "exclude": [
            "close",
            "send"
          ],
          "note": "art/text children do not intercept; own invisible catcher under controls"
        },
        {
          "id": "backdrop",
          "x": 0,
          "y": 0,
          "w": 941,
          "h": 1672,
          "action": "close-card",
          "enabled": true,
          "z": 101,
          "exclude": [
            "roster",
            "card.body",
            "close",
            "send"
          ],
          "note": "roster hit areas have precedence and stop propagation"
        },
        {
          "id": "roster",
          "inherit": "existing GameRoster seat buttons",
          "band": {
            "x": 0,
            "y": 284,
            "w": 941,
            "h": 175
          },
          "enabled": true,
          "z": 240,
          "action": "existing player-card action",
          "stopPropagation": true,
          "doNotMove": true
        }
      ]
    },
    "male": {
      "basePiece": "card.base.male",
      "color": "#28beff",
      "hue": 204,
      "smallSymbolPiece": "symbol.male",
      "largeSymbol": "in card base",
      "crown": "in card base",
      "avatarId": "snw-cast-0002",
      "elements": [
        {
          "id": "title.pill",
          "piece": "pill.large.png",
          "x": 103.831,
          "y": 355.253,
          "w": 731.758,
          "h": 104.494,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 119,
            "y": 370,
            "w": 701,
            "h": 75
          },
          "filter": "hue-rotate(17deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "card.base",
          "piece": "card.base.male",
          "x": 41,
          "y": 443,
          "w": 857,
          "h": 1143,
          "render": "border-image",
          "slicePx": {
            "top": 332,
            "right": 126,
            "bottom": 198,
            "left": 126
          },
          "borderWidthStage": {
            "top": 332,
            "right": 126,
            "bottom": 198,
            "left": 126
          },
          "z": 110,
          "neonBox": {
            "x": 66,
            "y": 465,
            "w": 803,
            "h": 1077
          },
          "cornerRule": "all source corners at 1:1 registered scale; only middle strips stretch",
          "masterResolutionRule": "keep this stage box and borderWidthStage fixed; multiply source slicePx/sourceRect by newMasterDimensions/currentMasterDimensions after remeasurement; no layout rescale"
        },
        {
          "id": "crown",
          "render": "in-base",
          "parent": "card.base",
          "x": 221,
          "y": 547,
          "w": 61,
          "h": 53,
          "z": 110
        },
        {
          "id": "big.symbol",
          "render": "in-base",
          "parent": "card.base",
          "x": 715,
          "y": 586,
          "w": 109,
          "h": 115,
          "z": 110
        },
        {
          "id": "print.0",
          "piece": "print.1",
          "x": 522.89,
          "y": 588.47,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": -14.13,
          "transformOrigin": "50% 50%",
          "z": 120,
          "referenceRotatedBox": {
            "x": 505.64,
            "y": 576.35,
            "w": 184.5,
            "h": 217.24
          },
          "referenceCentre": {
            "x": 597.89,
            "y": 684.97
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.male.victory",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.1",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.male.victory",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "print.1",
          "piece": "print.2",
          "x": 633.995,
          "y": 717.035,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": 15.71,
          "transformOrigin": "50% 50%",
          "z": 140,
          "referenceRotatedBox": {
            "x": 622.81,
            "y": 706.08,
            "w": 172.37,
            "h": 214.91
          },
          "referenceCentre": {
            "x": 708.995,
            "y": 813.535
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.male.thinking",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.2",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.male.thinking",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "print.2",
          "piece": "print.3",
          "x": 683.855,
          "y": 840.175,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": -14.69,
          "transformOrigin": "50% 50%",
          "z": 150,
          "referenceRotatedBox": {
            "x": 660.27,
            "y": 837.77,
            "w": 197.17,
            "h": 197.81
          },
          "referenceCentre": {
            "x": 758.855,
            "y": 936.675
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.male.flirt",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.3",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.male.flirt",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "avatar.happy",
          "piece": "avatar.male.happy",
          "x": 187.5,
          "y": 685,
          "w": 560,
          "h": 384,
          "render": "avatar",
          "z": 130,
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "trimTransparentThreshold": 4,
          "clip": {
            "type": "rect",
            "x": 187.5,
            "y": 685,
            "w": 560,
            "h": 384
          },
          "centredOn": "measured card centre",
          "cropRule": "trim transparent exterior only, uniformly cover measured box, centre horizontally, crop bottom; no stretch"
        },
        {
          "id": "age.divider",
          "render": "css-rule",
          "x": 264,
          "y": 718,
          "w": 3,
          "h": 92,
          "z": 160,
          "css": {
            "background": "rgba(255,255,255,.6)"
          },
          "note": "plain 3-unit separator explicitly allowed by stage-2 brief; not a replacement UI surface"
        },
        {
          "id": "small.symbol",
          "piece": "symbol.male",
          "x": 281,
          "y": 723.5,
          "w": 68,
          "h": 68,
          "render": "image",
          "sourceRect": {
            "x": 5,
            "y": 5,
            "w": 83,
            "h": 83
          },
          "z": 170,
          "filter": "hue-rotate(0deg)"
        },
        {
          "id": "flag.reserved",
          "render": "reserved",
          "x": 111,
          "y": 830,
          "w": 64,
          "h": 48,
          "empty": true,
          "z": 160,
          "ownerDecision": "flag asset undecided"
        },
        {
          "id": "tag.0",
          "piece": "create.pill.off",
          "x": 99.837,
          "y": 1033.023,
          "w": 269.767,
          "h": 113.953,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 121,
            "y": 1055,
            "w": 225,
            "h": 70
          },
          "filter": "hue-rotate(45.71deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 0,
          "category": "ROLE",
          "referenceHue": 268.71
        },
        {
          "id": "tag.1",
          "piece": "create.pill.off",
          "x": 338.837,
          "y": 1033.023,
          "w": 261.767,
          "h": 113.953,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 360,
            "y": 1055,
            "w": 217,
            "h": 70
          },
          "filter": "hue-rotate(-5.81deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 1,
          "category": "EXPERIENCES",
          "referenceHue": 217.19
        },
        {
          "id": "tag.2",
          "piece": "create.pill.off",
          "x": 568.837,
          "y": 1033.023,
          "w": 269.767,
          "h": 113.953,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 590,
            "y": 1055,
            "w": 225,
            "h": 70
          },
          "filter": "hue-rotate(-188.5deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 2,
          "category": "MONEY",
          "referenceHue": 34.5
        },
        {
          "id": "tag.3",
          "piece": "create.pill.off",
          "x": 100.837,
          "y": 1117.023,
          "w": 268.767,
          "h": 113.953,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 122,
            "y": 1139,
            "w": 224,
            "h": 70
          },
          "filter": "hue-rotate(93.02deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 3,
          "category": "TALK",
          "referenceHue": 316.02
        },
        {
          "id": "tag.4",
          "piece": "create.pill.off",
          "x": 338.837,
          "y": 1117.023,
          "w": 261.767,
          "h": 113.953,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 360,
            "y": 1139,
            "w": 217,
            "h": 70
          },
          "filter": "hue-rotate(36.71deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 4,
          "category": "SHARING",
          "referenceHue": 259.71
        },
        {
          "id": "tag.5",
          "piece": "create.pill.off",
          "x": 570.837,
          "y": 1117.023,
          "w": 267.767,
          "h": 113.953,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 592,
            "y": 1139,
            "w": 223,
            "h": 70
          },
          "filter": "hue-rotate(-56.18deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 5,
          "category": "TEMPO",
          "referenceHue": 166.82
        },
        {
          "id": "bio.pill",
          "piece": "pill.large.png",
          "x": 108.18,
          "y": 1224.73,
          "w": 717.191,
          "h": 136.539,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 128,
            "y": 1244,
            "w": 677,
            "h": 98
          },
          "filter": "hue-rotate(17deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "quote.0",
          "piece": "quote.open",
          "x": 153,
          "y": 1266.896,
          "w": 52,
          "h": 38.209,
          "render": "image",
          "sourceRect": {
            "x": 17,
            "y": 18,
            "w": 230,
            "h": 169
          },
          "z": 170,
          "color": "#28beff"
        },
        {
          "id": "quote.1",
          "piece": "quote.close",
          "x": 730,
          "y": 1268.114,
          "w": 52,
          "h": 38.772,
          "render": "image",
          "sourceRect": {
            "x": 17,
            "y": 16,
            "w": 228,
            "h": 170
          },
          "z": 170,
          "color": "#28beff"
        },
        {
          "id": "send.plate",
          "piece": "cta.plate.png",
          "x": 249,
          "y": 1360.86,
          "w": 433,
          "h": 126.28,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 331,
            "bottom": 0,
            "left": 331
          },
          "filter": "none",
          "z": 160,
          "capRule": "126.28 * 331 / 326 = 128.2155828221; Crew CSS rounds to 128.2",
          "source": "CrewSheet.tsx + app.css .mc-send"
        },
        {
          "id": "send.icon",
          "piece": "icon.paper-plane",
          "render": "image",
          "x": 309,
          "y": 1399,
          "w": 64,
          "h": 56,
          "z": 170,
          "filter": "brightness(0)",
          "visible": false,
          "reason": "optional icon omitted: fixed 56 word plus plane and gap exceeds reference width",
          "wordShift": 0
        },
        {
          "id": "close",
          "piece": "close",
          "x": 775.225,
          "y": 493,
          "w": 70.55,
          "h": 68,
          "render": "image",
          "sourceRect": {
            "x": 33,
            "y": 38,
            "w": 166,
            "h": 160
          },
          "z": 170
        },
        {
          "id": "timer.pill",
          "piece": "pill.large.png",
          "x": 145.843,
          "y": 1548.236,
          "w": 641.708,
          "h": 97.528,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 160,
            "y": 1562,
            "w": 613,
            "h": 70
          },
          "filter": "hue-rotate(17deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "timer.clock",
          "piece": "icon.clock",
          "x": 190,
          "y": 1578,
          "w": 40,
          "h": 40,
          "render": "image",
          "sourceRect": {
            "x": 5,
            "y": 5,
            "w": 70,
            "h": 70
          },
          "z": 170
        },
        {
          "id": "timer.track",
          "piece": "pill.large.png",
          "x": 254.742,
          "y": 1579.888,
          "w": 420.663,
          "h": 36.225,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 260,
            "y": 1585,
            "w": 410,
            "h": 26
          },
          "filter": "hue-rotate(17deg) brightness(0.48)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "timer.fill",
          "piece": "cta.plate.png",
          "x": 255.822,
          "y": 1582.113,
          "w": 418.356,
          "h": 31.676,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 331,
            "bottom": 0,
            "left": 331
          },
          "neonBox": {
            "x": 260,
            "y": 1586,
            "w": 410,
            "h": 24
          },
          "filter": "hue-rotate(161deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "clipRule": {
            "type": "inset",
            "right": "(1 - clamp(remainingMs / durationMs,0,1)) * 100%",
            "referenceFraction": 0.373,
            "referenceFillBox": {
              "x": 260,
              "y": 1586,
              "w": 153,
              "h": 24
            },
            "zero": "hide",
            "note": "full-width 3-slice rendered once; clip reveals left fraction; never squeeze either cap. Right clipping edge is straight and differs from reference."
          }
        }
      ],
      "texts": [
        {
          "id": "title",
          "text": "WHAT WOULD WILHELMI ANSWER?",
          "role": "title",
          "font": "Nunito",
          "weight": 800,
          "size": 26.25,
          "trackingEm": 0,
          "x": 183,
          "y": 396,
          "w": 573,
          "h": 45,
          "lineHeight": 45,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 22,
          "proofInkTop": 396,
          "proofInkAlign": "center",
          "textTransform": "uppercase",
          "displayText": "WHAT WOULD WILHELMI ANSWER?",
          "binding": "player.displayName",
          "spans": [
            {
              "text": "WHAT WOULD "
            },
            {
              "text": "WILHELMI",
              "color": "#28beff",
              "binding": "player.displayName"
            },
            {
              "text": " ANSWER?"
            }
          ],
          "measured": {
            "advance": 472.498,
            "inkW": 472,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          },
          "initialSize": 30.25,
          "familyReduction": 0.868
        },
        {
          "id": "name",
          "text": "Wilhelmi",
          "role": "name",
          "font": "Nunito",
          "weight": 900,
          "size": 99,
          "trackingEm": 0,
          "x": 108,
          "y": 606,
          "w": 353,
          "h": 76,
          "lineHeight": 76,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 72,
          "proofInkTop": 606,
          "proofInkAlign": "left",
          "gradient": [
            "#ffffff",
            "#28beff"
          ],
          "binding": "player.displayName",
          "overflow": "ellipsis",
          "proposal": true,
          "measured": {
            "advance": 444.807,
            "inkW": 438,
            "inkH": 76,
            "baselineOffset": 74,
            "missingGlyphs": []
          },
          "proposalDisplay": "Wilh…"
        },
        {
          "id": "age",
          "text": "24",
          "role": "age",
          "font": "Nunito",
          "weight": 900,
          "size": 120.25,
          "trackingEm": 0,
          "x": 111,
          "y": 715,
          "w": 139,
          "h": 95,
          "lineHeight": 95,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 95,
          "proofInkTop": 715,
          "proofInkAlign": "left",
          "binding": "player.age",
          "measured": {
            "advance": 144,
            "inkW": 139,
            "inkH": 88,
            "baselineOffset": 86,
            "missingGlyphs": []
          },
          "initialSize": 130.75,
          "familyReduction": 0.92
        },
        {
          "id": "country",
          "text": "Germany",
          "role": "country",
          "font": "Nunito",
          "weight": 800,
          "size": 36.5,
          "trackingEm": 0,
          "x": 190,
          "y": 842,
          "w": 160,
          "h": 37,
          "lineHeight": 37,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 29,
          "proofInkTop": 842,
          "proofInkAlign": "left",
          "binding": "player.country",
          "measured": {
            "advance": 155.928,
            "inkW": 154,
            "inkH": 34,
            "baselineOffset": 26.5,
            "missingGlyphs": []
          },
          "initialSize": 39.75,
          "familyReduction": 0.918
        },
        {
          "id": "city",
          "text": "Berlin",
          "role": "city",
          "font": "Nunito",
          "weight": 700,
          "size": 28,
          "trackingEm": 0,
          "x": 163,
          "y": 903,
          "w": 79,
          "h": 23,
          "lineHeight": 23,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 22,
          "proofInkTop": 903,
          "proofInkAlign": "left",
          "binding": "player.city",
          "emptyBehavior": "blank; no movement",
          "pin": false,
          "measured": {
            "advance": 77.868,
            "inkW": 75,
            "inkH": 21,
            "baselineOffset": 20.5,
            "missingGlyphs": []
          },
          "initialSize": 30.25,
          "familyReduction": 0.926
        },
        {
          "id": "tag.0.word",
          "text": "Observer",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 153,
          "y": 1055,
          "w": 161,
          "h": 70,
          "lineHeight": 70,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 1055,
          "proofInkAlign": "center",
          "proofInkCentreY": 1090,
          "binding": "player.tags[0]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 111.488,
            "inkW": 111,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.1.word",
          "text": "Curious",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 392,
          "y": 1055,
          "w": 153,
          "h": 70,
          "lineHeight": 70,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 1055,
          "proofInkAlign": "center",
          "proofInkCentreY": 1090,
          "binding": "player.tags[1]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 91.936,
            "inkW": 90,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.2.word",
          "text": "Investor",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 622,
          "y": 1055,
          "w": 161,
          "h": 70,
          "lineHeight": 70,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 1055,
          "proofInkAlign": "center",
          "proofInkCentreY": 1090,
          "binding": "player.tags[2]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 97.526,
            "inkW": 96,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.3.word",
          "text": "Logical",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 154,
          "y": 1139,
          "w": 160,
          "h": 70,
          "lineHeight": 70,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 1139,
          "proofInkAlign": "center",
          "proofInkCentreY": 1174,
          "binding": "player.tags[3]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 86.502,
            "inkW": 85,
            "inkH": 24,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.4.word",
          "text": "Reserved",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 392,
          "y": 1139,
          "w": 153,
          "h": 70,
          "lineHeight": 70,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 19,
          "proofInkTop": 1139,
          "proofInkAlign": "center",
          "proofInkCentreY": 1174,
          "binding": "player.tags[4]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 112.476,
            "inkW": 109,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.5.word",
          "text": "Night owl",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 624,
          "y": 1139,
          "w": 159,
          "h": 70,
          "lineHeight": 70,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 1139,
          "proofInkAlign": "center",
          "proofInkCentreY": 1174,
          "binding": "player.tags[5]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 119.21,
            "inkW": 118,
            "inkH": 24,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "bio.0",
          "text": "Quiet charm, late-night thoughts, and a sharp",
          "role": "bio",
          "font": "Nunito",
          "weight": 600,
          "size": 19,
          "trackingEm": 0,
          "x": 220,
          "y": 1271,
          "w": 493,
          "h": 29,
          "lineHeight": 29,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 17,
          "proofInkTop": 1271,
          "proofInkAlign": "center",
          "binding": "player.bio",
          "line": 0,
          "maxLines": 2,
          "linePitch": 29,
          "emptyBehavior": "hide words and quotes; keep capsule and every box fixed",
          "measured": {
            "advance": 395.2,
            "inkW": 394,
            "inkH": 18,
            "baselineOffset": 14,
            "missingGlyphs": []
          }
        },
        {
          "id": "bio.1",
          "text": "eye for details. I open up slowly, but I mean it when I do.",
          "role": "bio",
          "font": "Nunito",
          "weight": 600,
          "size": 19,
          "trackingEm": 0,
          "x": 220,
          "y": 1300,
          "w": 493,
          "h": 29,
          "lineHeight": 29,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 15,
          "proofInkTop": 1300,
          "proofInkAlign": "center",
          "binding": "player.bio",
          "line": 1,
          "maxLines": 2,
          "linePitch": 29,
          "emptyBehavior": "hide words and quotes; keep capsule and every box fixed",
          "measured": {
            "advance": 485.431,
            "inkW": 484,
            "inkH": 18,
            "baselineOffset": 14,
            "missingGlyphs": []
          }
        },
        {
          "id": "send.label",
          "text": "Send Message",
          "role": "send",
          "font": "Nunito",
          "weight": 800,
          "size": 56,
          "trackingEm": 0.01,
          "x": 249,
          "y": 1360.86,
          "w": 433,
          "h": 126.28,
          "lineHeight": 56,
          "align": "center",
          "color": "#000000",
          "z": 180,
          "referenceCap": 26,
          "proofInkTop": 1360.86,
          "proofInkAlign": "center",
          "proofInkCentreY": 1424,
          "wordShift": 0,
          "measured": {
            "advance": 387.184,
            "inkW": 384,
            "inkH": 52,
            "baselineOffset": 40.5,
            "missingGlyphs": []
          }
        },
        {
          "id": "timer.digits",
          "text": "5s",
          "role": "timer",
          "font": "Nunito",
          "weight": 900,
          "size": 25.25,
          "trackingEm": 0,
          "x": 684,
          "y": 1585,
          "w": 65,
          "h": 40,
          "lineHeight": 40,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 27,
          "proofInkTop": 1585,
          "proofInkAlign": "center",
          "proofInkCentreY": 1598.5,
          "binding": "ceil(remainingMs/1000) + \"s\"",
          "overflow": "visible",
          "numericVariant": "tabular-nums",
          "referenceSizeRule": "one timer family reduced if 120s, the protocol maximum, consumes the digits lane",
          "measured": {
            "advance": 27.4,
            "inkW": 26,
            "inkH": 19,
            "baselineOffset": 18,
            "missingGlyphs": []
          },
          "initialSize": 37.5,
          "familyReduction": 0.673
        }
      ],
      "hitTargets": [
        {
          "id": "close",
          "x": 752.5,
          "y": 469,
          "w": 116,
          "h": 116,
          "action": "close-card",
          "enabled": true,
          "z": 230,
          "stopPropagation": true,
          "ariaLabel": "Close player card"
        },
        {
          "id": "send",
          "x": 249,
          "y": 1360.86,
          "w": 433,
          "h": 126.28,
          "action": "open-player-message",
          "enabled": true,
          "z": 230,
          "stopPropagation": true,
          "disabledBehavior": "consume tap; never bubble to close-card",
          "ariaLabel": "Send Message"
        },
        {
          "id": "card.body",
          "x": 66,
          "y": 465,
          "w": 803,
          "h": 1077,
          "action": "close-card",
          "enabled": true,
          "z": 200,
          "exclude": [
            "close",
            "send"
          ],
          "note": "art/text children do not intercept; own invisible catcher under controls"
        },
        {
          "id": "backdrop",
          "x": 0,
          "y": 0,
          "w": 941,
          "h": 1672,
          "action": "close-card",
          "enabled": true,
          "z": 101,
          "exclude": [
            "roster",
            "card.body",
            "close",
            "send"
          ],
          "note": "roster hit areas have precedence and stop propagation"
        },
        {
          "id": "roster",
          "inherit": "existing GameRoster seat buttons",
          "band": {
            "x": 0,
            "y": 284,
            "w": 941,
            "h": 175
          },
          "enabled": true,
          "z": 240,
          "action": "existing player-card action",
          "stopPropagation": true,
          "doNotMove": true
        }
      ]
    },
    "other": {
      "basePiece": "card.base.other",
      "color": "#ffbf2c",
      "hue": 43,
      "smallSymbolPiece": "symbol.star",
      "largeSymbol": "in card base",
      "crown": "in card base",
      "avatarId": "snw-cast-0007",
      "elements": [
        {
          "id": "title.pill",
          "piece": "pill.large.png",
          "x": 102.831,
          "y": 355.253,
          "w": 733.758,
          "h": 104.494,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 118,
            "y": 370,
            "w": 703,
            "h": 75
          },
          "filter": "hue-rotate(-144deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "card.base",
          "piece": "card.base.other",
          "x": 43,
          "y": 446,
          "w": 852,
          "h": 1141,
          "render": "border-image",
          "slicePx": {
            "top": 330,
            "right": 126,
            "bottom": 197,
            "left": 126
          },
          "borderWidthStage": {
            "top": 330,
            "right": 126,
            "bottom": 197,
            "left": 126
          },
          "z": 110,
          "neonBox": {
            "x": 66,
            "y": 466,
            "w": 806,
            "h": 1077
          },
          "cornerRule": "all source corners at 1:1 registered scale; only middle strips stretch",
          "masterResolutionRule": "keep this stage box and borderWidthStage fixed; multiply source slicePx/sourceRect by newMasterDimensions/currentMasterDimensions after remeasurement; no layout rescale"
        },
        {
          "id": "crown",
          "render": "in-base",
          "parent": "card.base",
          "x": 226,
          "y": 548,
          "w": 65,
          "h": 56,
          "z": 110
        },
        {
          "id": "big.symbol",
          "render": "in-base",
          "parent": "card.base",
          "x": 707,
          "y": 575,
          "w": 137,
          "h": 139,
          "z": 110
        },
        {
          "id": "print.0",
          "piece": "print.1",
          "x": 538.295,
          "y": 580.35,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": -13.53,
          "transformOrigin": "50% 50%",
          "z": 120,
          "referenceRotatedBox": {
            "x": 520.89,
            "y": 566.68,
            "w": 184.81,
            "h": 220.34
          },
          "referenceCentre": {
            "x": 613.295,
            "y": 676.85
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.other.victory",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.1",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.other.victory",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "print.1",
          "piece": "print.2",
          "x": 657.4,
          "y": 717.525,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": 15.73,
          "transformOrigin": "50% 50%",
          "z": 140,
          "referenceRotatedBox": {
            "x": 634.01,
            "y": 704.94,
            "w": 196.78,
            "h": 218.17
          },
          "referenceCentre": {
            "x": 732.4,
            "y": 814.025
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.other.thinking",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.2",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.other.thinking",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "print.2",
          "piece": "print.3",
          "x": 696.94,
          "y": 865.21,
          "w": 150,
          "h": 193,
          "render": "print",
          "rotationDegrees": -14.98,
          "transformOrigin": "50% 50%",
          "z": 150,
          "referenceRotatedBox": {
            "x": 679.65,
            "y": 853.49,
            "w": 184.58,
            "h": 216.44
          },
          "referenceCentre": {
            "x": 771.94,
            "y": 961.71
          },
          "window": {
            "x": 7,
            "y": 8,
            "w": 136,
            "h": 144
          },
          "imagePiece": "avatar.other.flirt",
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "imageCrop": {
            "trimTransparentThreshold": 4,
            "topCentreFraction": 0.68
          },
          "layers": [
            {
              "role": "plate",
              "piece": "print.3",
              "z": 0
            },
            {
              "role": "portrait",
              "piece": "avatar.other.flirt",
              "z": 1,
              "clip": "window"
            }
          ],
          "clip": "clip the portrait to the print-local window; rotate plate and portrait together about the paper centre",
          "alphaRule": "source-over portrait with native alpha; no flatten, no aperture, no extra background; the complete plate is opaque",
          "scaleRule": "uniform whole-piece scaling; all nine print instances use the same 150 × 193 paper size"
        },
        {
          "id": "avatar.happy",
          "piece": "avatar.other.happy",
          "x": 183,
          "y": 683,
          "w": 572,
          "h": 399,
          "render": "avatar",
          "z": 130,
          "objectFit": "cover",
          "objectPosition": "50% 0%",
          "trimTransparentThreshold": 4,
          "clip": {
            "type": "rect",
            "x": 183,
            "y": 683,
            "w": 572,
            "h": 399
          },
          "centredOn": "measured card centre",
          "cropRule": "trim transparent exterior only, uniformly cover measured box, centre horizontally, crop bottom; no stretch"
        },
        {
          "id": "age.divider",
          "render": "css-rule",
          "x": 264,
          "y": 702,
          "w": 3,
          "h": 91,
          "z": 160,
          "css": {
            "background": "rgba(255,255,255,.6)"
          },
          "note": "plain 3-unit separator explicitly allowed by stage-2 brief; not a replacement UI surface"
        },
        {
          "id": "small.symbol",
          "piece": "symbol.star",
          "x": 280,
          "y": 696.268,
          "w": 93,
          "h": 87.464,
          "render": "image",
          "sourceRect": {
            "x": 4,
            "y": 4,
            "w": 84,
            "h": 79
          },
          "z": 170,
          "filter": "hue-rotate(-161deg)"
        },
        {
          "id": "flag.reserved",
          "render": "reserved",
          "x": 111,
          "y": 807,
          "w": 64,
          "h": 48,
          "empty": true,
          "z": 160,
          "ownerDecision": "flag asset undecided"
        },
        {
          "id": "tag.0",
          "piece": "create.pill.off",
          "x": 100.744,
          "y": 1053.965,
          "w": 267.849,
          "h": 109.07,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 121,
            "y": 1075,
            "w": 225,
            "h": 67
          },
          "filter": "hue-rotate(46.87deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 0,
          "category": "ROLE",
          "referenceHue": 269.87
        },
        {
          "id": "tag.1",
          "piece": "create.pill.off",
          "x": 339.744,
          "y": 1053.965,
          "w": 259.849,
          "h": 109.07,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 360,
            "y": 1075,
            "w": 217,
            "h": 67
          },
          "filter": "hue-rotate(-7.96deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 1,
          "category": "EXPERIENCES",
          "referenceHue": 215.04
        },
        {
          "id": "tag.2",
          "piece": "create.pill.off",
          "x": 570.744,
          "y": 1053.965,
          "w": 266.849,
          "h": 109.07,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 591,
            "y": 1075,
            "w": 224,
            "h": 67
          },
          "filter": "hue-rotate(-190.16deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 2,
          "category": "MONEY",
          "referenceHue": 32.84
        },
        {
          "id": "tag.3",
          "piece": "create.pill.off",
          "x": 100.744,
          "y": 1132.965,
          "w": 267.849,
          "h": 109.07,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 121,
            "y": 1154,
            "w": 225,
            "h": 67
          },
          "filter": "hue-rotate(95.85deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 3,
          "category": "TALK",
          "referenceHue": 318.85
        },
        {
          "id": "tag.4",
          "piece": "create.pill.off",
          "x": 339.744,
          "y": 1132.965,
          "w": 259.849,
          "h": 109.07,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 360,
            "y": 1154,
            "w": 217,
            "h": 67
          },
          "filter": "hue-rotate(37.54deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 4,
          "category": "SHARING",
          "referenceHue": 260.54
        },
        {
          "id": "tag.5",
          "piece": "create.pill.off",
          "x": 570.744,
          "y": 1132.965,
          "w": 267.849,
          "h": 109.07,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 84,
            "bottom": 0,
            "left": 84
          },
          "neonBox": {
            "x": 591,
            "y": 1154,
            "w": 225,
            "h": 67
          },
          "filter": "hue-rotate(-57.74deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "slot": 5,
          "category": "TEMPO",
          "referenceHue": 165.26
        },
        {
          "id": "bio.pill",
          "piece": "pill.large.png",
          "x": 107.787,
          "y": 1227.32,
          "w": 719.961,
          "h": 132.36,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 127,
            "y": 1246,
            "w": 681,
            "h": 95
          },
          "filter": "hue-rotate(-144deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "quote.0",
          "piece": "quote.open",
          "x": 151,
          "y": 1268.896,
          "w": 52,
          "h": 38.209,
          "render": "image",
          "sourceRect": {
            "x": 17,
            "y": 18,
            "w": 230,
            "h": 169
          },
          "z": 170,
          "color": "#ffbf2c"
        },
        {
          "id": "quote.1",
          "piece": "quote.close",
          "x": 732,
          "y": 1270.614,
          "w": 52,
          "h": 38.772,
          "render": "image",
          "sourceRect": {
            "x": 17,
            "y": 16,
            "w": 228,
            "h": 170
          },
          "z": 170,
          "color": "#ffbf2c"
        },
        {
          "id": "send.plate",
          "piece": "cta.plate.png",
          "x": 248,
          "y": 1358.86,
          "w": 435,
          "h": 126.28,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 331,
            "bottom": 0,
            "left": 331
          },
          "filter": "none",
          "z": 160,
          "capRule": "126.28 * 331 / 326 = 128.2155828221; Crew CSS rounds to 128.2",
          "source": "CrewSheet.tsx + app.css .mc-send"
        },
        {
          "id": "send.icon",
          "piece": "icon.paper-plane",
          "render": "image",
          "x": 309,
          "y": 1398,
          "w": 64,
          "h": 56,
          "z": 170,
          "filter": "brightness(0)",
          "visible": false,
          "reason": "optional icon omitted: fixed 56 word plus plane and gap exceeds reference width",
          "wordShift": 0
        },
        {
          "id": "close",
          "piece": "close",
          "x": 775.206,
          "y": 492,
          "w": 71.588,
          "h": 69,
          "render": "image",
          "sourceRect": {
            "x": 33,
            "y": 38,
            "w": 166,
            "h": 160
          },
          "z": 170
        },
        {
          "id": "timer.pill",
          "piece": "pill.large.png",
          "x": 146.045,
          "y": 1548.433,
          "w": 641.298,
          "h": 96.135,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 160,
            "y": 1562,
            "w": 613,
            "h": 69
          },
          "filter": "hue-rotate(-144deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "timer.clock",
          "piece": "icon.clock",
          "x": 190,
          "y": 1577.5,
          "w": 40,
          "h": 40,
          "render": "image",
          "sourceRect": {
            "x": 5,
            "y": 5,
            "w": 70,
            "h": 70
          },
          "z": 170
        },
        {
          "id": "timer.track",
          "piece": "pill.large.png",
          "x": 254.944,
          "y": 1580.084,
          "w": 421.253,
          "h": 34.831,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 124,
            "bottom": 0,
            "left": 124
          },
          "neonBox": {
            "x": 260,
            "y": 1585,
            "w": 411,
            "h": 25
          },
          "filter": "hue-rotate(-144deg) brightness(0.48)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH"
        },
        {
          "id": "timer.fill",
          "piece": "cta.plate.png",
          "x": 255.648,
          "y": 1580.951,
          "w": 419.704,
          "h": 32.996,
          "render": "3-slice",
          "slicePx": {
            "top": 0,
            "right": 331,
            "bottom": 0,
            "left": 331
          },
          "neonBox": {
            "x": 260,
            "y": 1585,
            "w": 411,
            "h": 25
          },
          "filter": "hue-rotate(0deg)",
          "z": 150,
          "alphaRule": "retain source alpha; no opaque repaint or extra fill layer",
          "capRule": "h * slicePx.left / source pixelH",
          "clipRule": {
            "type": "inset",
            "right": "(1 - clamp(remainingMs / durationMs,0,1)) * 100%",
            "referenceFraction": 0.37,
            "referenceFillBox": {
              "x": 260,
              "y": 1585,
              "w": 152,
              "h": 25
            },
            "zero": "hide",
            "note": "full-width 3-slice rendered once; clip reveals left fraction; never squeeze either cap. Right clipping edge is straight and differs from reference."
          }
        }
      ],
      "texts": [
        {
          "id": "title",
          "text": "WHAT WOULD ALEXANDRIELLE ANSWER?",
          "role": "title",
          "font": "Nunito",
          "weight": 800,
          "size": 26.25,
          "trackingEm": 0,
          "x": 182,
          "y": 397,
          "w": 575,
          "h": 45,
          "lineHeight": 45,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 22,
          "proofInkTop": 397,
          "proofInkAlign": "center",
          "textTransform": "uppercase",
          "displayText": "WHAT WOULD ALEXANDRIELLE ANSWER?",
          "binding": "player.displayName",
          "spans": [
            {
              "text": "WHAT WOULD "
            },
            {
              "text": "ALEXANDRIELLE",
              "color": "#ffbf2c",
              "binding": "player.displayName"
            },
            {
              "text": " ANSWER?"
            }
          ],
          "measured": {
            "advance": 553.306,
            "inkW": 553,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          },
          "initialSize": 30.25,
          "familyReduction": 0.868
        },
        {
          "id": "name",
          "text": "Alexandrielle",
          "role": "name",
          "font": "Nunito",
          "weight": 900,
          "size": 86.5,
          "trackingEm": 0,
          "x": 101,
          "y": 601,
          "w": 414,
          "h": 68,
          "lineHeight": 68,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 63,
          "proofInkTop": 601,
          "proofInkAlign": "left",
          "gradient": [
            "#ffffff",
            "#ffbf2c"
          ],
          "binding": "player.displayName",
          "overflow": "ellipsis",
          "proposal": true,
          "measured": {
            "advance": 565.797,
            "inkW": 563,
            "inkH": 66,
            "baselineOffset": 64.5,
            "missingGlyphs": []
          },
          "proposalDisplay": "Alexan…"
        },
        {
          "id": "age",
          "text": "23",
          "role": "age",
          "font": "Nunito",
          "weight": 900,
          "size": 113.75,
          "trackingEm": 0,
          "x": 113,
          "y": 702,
          "w": 137,
          "h": 92,
          "lineHeight": 92,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 90,
          "proofInkTop": 702,
          "proofInkAlign": "left",
          "binding": "player.age",
          "measured": {
            "advance": 136.8,
            "inkW": 128,
            "inkH": 84,
            "baselineOffset": 82,
            "missingGlyphs": []
          },
          "initialSize": 123.75,
          "familyReduction": 0.919
        },
        {
          "id": "country",
          "text": "Canada",
          "role": "country",
          "font": "Nunito",
          "weight": 800,
          "size": 36.5,
          "trackingEm": 0,
          "x": 192,
          "y": 815,
          "w": 127,
          "h": 30,
          "lineHeight": 30,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 29,
          "proofInkTop": 815,
          "proofInkAlign": "left",
          "binding": "player.country",
          "measured": {
            "advance": 129.247,
            "inkW": 126,
            "inkH": 27,
            "baselineOffset": 26.5,
            "missingGlyphs": []
          },
          "initialSize": 39.75,
          "familyReduction": 0.918
        },
        {
          "id": "city",
          "text": "Toronto",
          "role": "city",
          "font": "Nunito",
          "weight": 700,
          "size": 30.5,
          "trackingEm": 0,
          "x": 156,
          "y": 876,
          "w": 111,
          "h": 24,
          "lineHeight": 24,
          "align": "left",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 24,
          "proofInkTop": 876,
          "proofInkAlign": "left",
          "binding": "player.city",
          "emptyBehavior": "blank; no movement",
          "pin": false,
          "measured": {
            "advance": 110.38,
            "inkW": 110,
            "inkH": 22,
            "baselineOffset": 21.5,
            "missingGlyphs": []
          },
          "initialSize": 33,
          "familyReduction": 0.924
        },
        {
          "id": "tag.0.word",
          "text": "Team player",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 153,
          "y": 1075,
          "w": 161,
          "h": 67,
          "lineHeight": 67,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1075,
          "proofInkAlign": "center",
          "proofInkCentreY": 1108.5,
          "binding": "player.tags[0]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 147.966,
            "inkW": 149,
            "inkH": 24,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.1.word",
          "text": "Curious",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 392,
          "y": 1075,
          "w": 153,
          "h": 67,
          "lineHeight": 67,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1075,
          "proofInkAlign": "center",
          "proofInkCentreY": 1108.5,
          "binding": "player.tags[1]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 91.936,
            "inkW": 90,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.2.word",
          "text": "Collector",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 623,
          "y": 1075,
          "w": 160,
          "h": 67,
          "lineHeight": 67,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 21,
          "proofInkTop": 1075,
          "proofInkAlign": "center",
          "proofInkCentreY": 1108.5,
          "binding": "player.tags[2]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 109.642,
            "inkW": 109,
            "inkH": 20,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.3.word",
          "text": "Playful",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 153,
          "y": 1154,
          "w": 161,
          "h": 67,
          "lineHeight": 67,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 1154,
          "proofInkAlign": "center",
          "proofInkCentreY": 1187.5,
          "binding": "player.tags[3]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 86.034,
            "inkW": 84,
            "inkH": 24,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.4.word",
          "text": "Expressive",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 392,
          "y": 1154,
          "w": 153,
          "h": 67,
          "lineHeight": 67,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 1154,
          "proofInkAlign": "center",
          "proofInkCentreY": 1187.5,
          "binding": "player.tags[4]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 128.934,
            "inkW": 127,
            "inkH": 24,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "tag.5.word",
          "text": "Night owl",
          "role": "tag",
          "font": "Nunito",
          "weight": 700,
          "size": 26.25,
          "trackingEm": 0,
          "x": 623,
          "y": 1154,
          "w": 161,
          "h": 67,
          "lineHeight": 67,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 20,
          "proofInkTop": 1154,
          "proofInkAlign": "center",
          "proofInkCentreY": 1187.5,
          "binding": "player.tags[5]",
          "nullBehavior": "word empty; pill retained; proposal",
          "measured": {
            "advance": 119.21,
            "inkW": 118,
            "inkH": 24,
            "baselineOffset": 19,
            "missingGlyphs": []
          }
        },
        {
          "id": "bio.0",
          "text": "Soft chaos, late-night spark, and a heart full of stories.",
          "role": "bio",
          "font": "Nunito",
          "weight": 600,
          "size": 19.75,
          "trackingEm": 0,
          "x": 219,
          "y": 1272,
          "w": 497,
          "h": 29,
          "lineHeight": 29,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 15,
          "proofInkTop": 1272,
          "proofInkAlign": "center",
          "binding": "player.bio",
          "line": 0,
          "maxLines": 2,
          "linePitch": 29,
          "emptyBehavior": "hide words and quotes; keep capsule and every box fixed",
          "measured": {
            "advance": 495.08,
            "inkW": 494,
            "inkH": 19,
            "baselineOffset": 14.5,
            "missingGlyphs": []
          }
        },
        {
          "id": "bio.1",
          "text": "Easy to meet, hard to forget.",
          "role": "bio",
          "font": "Nunito",
          "weight": 600,
          "size": 19.75,
          "trackingEm": 0,
          "x": 219,
          "y": 1301,
          "w": 497,
          "h": 29,
          "lineHeight": 29,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 15,
          "proofInkTop": 1301,
          "proofInkAlign": "center",
          "binding": "player.bio",
          "line": 1,
          "maxLines": 2,
          "linePitch": 29,
          "emptyBehavior": "hide words and quotes; keep capsule and every box fixed",
          "measured": {
            "advance": 258.46,
            "inkW": 256,
            "inkH": 19,
            "baselineOffset": 14.5,
            "missingGlyphs": []
          }
        },
        {
          "id": "send.label",
          "text": "Send Message",
          "role": "send",
          "font": "Nunito",
          "weight": 800,
          "size": 56,
          "trackingEm": 0.01,
          "x": 248,
          "y": 1358.86,
          "w": 435,
          "h": 126.28,
          "lineHeight": 56,
          "align": "center",
          "color": "#000000",
          "z": 180,
          "referenceCap": 27,
          "proofInkTop": 1358.86,
          "proofInkAlign": "center",
          "proofInkCentreY": 1422,
          "wordShift": 0,
          "measured": {
            "advance": 387.184,
            "inkW": 384,
            "inkH": 52,
            "baselineOffset": 40.5,
            "missingGlyphs": []
          }
        },
        {
          "id": "timer.digits",
          "text": "5s",
          "role": "timer",
          "font": "Nunito",
          "weight": 900,
          "size": 25.25,
          "trackingEm": 0,
          "x": 685,
          "y": 1585,
          "w": 64,
          "h": 40,
          "lineHeight": 40,
          "align": "center",
          "color": "#ffffff",
          "z": 180,
          "referenceCap": 27,
          "proofInkTop": 1585,
          "proofInkAlign": "center",
          "proofInkCentreY": 1598.5,
          "binding": "ceil(remainingMs/1000) + \"s\"",
          "overflow": "visible",
          "numericVariant": "tabular-nums",
          "referenceSizeRule": "one timer family reduced if 120s, the protocol maximum, consumes the digits lane",
          "measured": {
            "advance": 27.4,
            "inkW": 26,
            "inkH": 19,
            "baselineOffset": 18,
            "missingGlyphs": []
          },
          "initialSize": 37.5,
          "familyReduction": 0.673
        }
      ],
      "hitTargets": [
        {
          "id": "close",
          "x": 753,
          "y": 468.5,
          "w": 116,
          "h": 116,
          "action": "close-card",
          "enabled": true,
          "z": 230,
          "stopPropagation": true,
          "ariaLabel": "Close player card"
        },
        {
          "id": "send",
          "x": 248,
          "y": 1358.86,
          "w": 435,
          "h": 126.28,
          "action": "open-player-message",
          "enabled": true,
          "z": 230,
          "stopPropagation": true,
          "disabledBehavior": "consume tap; never bubble to close-card",
          "ariaLabel": "Send Message"
        },
        {
          "id": "card.body",
          "x": 66,
          "y": 466,
          "w": 806,
          "h": 1077,
          "action": "close-card",
          "enabled": true,
          "z": 200,
          "exclude": [
            "close",
            "send"
          ],
          "note": "art/text children do not intercept; own invisible catcher under controls"
        },
        {
          "id": "backdrop",
          "x": 0,
          "y": 0,
          "w": 941,
          "h": 1672,
          "action": "close-card",
          "enabled": true,
          "z": 101,
          "exclude": [
            "roster",
            "card.body",
            "close",
            "send"
          ],
          "note": "roster hit areas have precedence and stop propagation"
        },
        {
          "id": "roster",
          "inherit": "existing GameRoster seat buttons",
          "band": {
            "x": 0,
            "y": 284,
            "w": 941,
            "h": 175
          },
          "enabled": true,
          "z": 240,
          "action": "existing player-card action",
          "stopPropagation": true,
          "doNotMove": true
        }
      ]
    }
  },
  "states": {
    "intro": {
      "durationMs": 5000,
      "timerVisible": true,
      "timerDigits": "ceil(max(0,deadlineMs-nowMs)/1000) + \"s\"",
      "timerFraction": "clamp((deadlineMs-nowMs)/5000,0,1)",
      "onExpiry": "close-card",
      "position": "popup.groups[theme]; no translation",
      "initialFraction": 1
    },
    "manual_predict": {
      "timerVisible": true,
      "clock": "use the current PREDICT deadline and duration; never restart the game timer",
      "timerDigits": "ceil(max(0,predictDeadlineMs-nowMs)/1000) + \"s\"",
      "timerFraction": "clamp((predictDeadlineMs-nowMs)/predictDurationMs,0,1)",
      "onPhaseExit": "close-card",
      "position": "same as intro"
    },
    "untimed": {
      "contexts": [
        "lobby",
        "after match"
      ],
      "timerVisible": false,
      "hiddenElements": [
        "timer.pill",
        "timer.clock",
        "timer.track",
        "timer.fill"
      ],
      "hiddenTexts": [
        "timer.digits"
      ],
      "position": "popup.groups[theme].untimed; translate 0,0; do not recenter or move the card down"
    },
    "bio_empty": {
      "hiddenTexts": [
        "bio.0",
        "bio.1"
      ],
      "hiddenElements": [
        "quote.0",
        "quote.1"
      ],
      "keep": [
        "bio.pill",
        "all other boxes"
      ],
      "movement": 0
    },
    "send_disabled": {
      "elementOverrides": {
        "send.plate": {
          "filter": "brightness(.58)",
          "opacity": 0.95
        }
      },
      "hitOverrides": {
        "send": {
          "enabled": false,
          "stopPropagation": true
        }
      },
      "textRule": "black text unchanged; no opacity on the word; no alternative disabled art",
      "basis": "owner-specified KitPiece off, supersedes .mc-send.off brightness(.5)"
    },
    "incomplete_profile": {
      "status": "PROPOSAL",
      "tags": [
        null,
        null,
        null,
        null,
        null,
        null
      ],
      "tagPills": "all six remain at identical positions with their native artwork and tint",
      "tagWords": "empty for null; no fabricated tag, dash or fallback label",
      "bio": "empty behavior if null",
      "countryCity": "blank if absent, preserve boxes",
      "send": "disabled if target cannot receive a message",
      "movement": 0
    },
    "name_13": {
      "status": "PROPOSAL — owner chooses ellipsis or second line",
      "example": "AlexandrielleX",
      "characters": 13,
      "behavior": "ellipsis at each theme’s measured reference name size; no per-name reduction, font substitution or horizontal squeeze",
      "title": "ellipsis only the name span if it exceeds its reserved title lane",
      "alternative": "second line retains cap size but collides with age/portrait in current geometry; would need a separate approved layout"
    },
    "unavailable": {
      "status": "review proposal for error completeness",
      "text": "Card unavailable",
      "help": "Tap to close and try again.",
      "hideProfile": true,
      "sendDisabled": true,
      "cardPosition": "unchanged",
      "close": "body, backdrop and close button remain active"
    },
    "reference_comparison": {
      "fixtureOnly": true,
      "digits": "5s",
      "fraction": "the measured reference fill width / track width (~.38)",
      "note": "image comparison only. Not a live intro state."
    }
  },
  "examples": {},
  "textContract": {
    "font": "Nunito",
    "fontFile": "apps/client/public/fonts/Nunito-latin.woff2",
    "measurement": "local HarfBuzz/FreeType at 2x; alpha >=170 cap measurement; widths never squeezed",
    "position": "schema-2 x/y/w/h are live-text lanes; proofInkTop fixes the measured ink position; baseline = proofInkTop + baselineOffset; photo-print lettering is baked artwork and has no text node",
    "tagFamily": {
      "size": 26.25,
      "weight": 700,
      "capHeight": 19,
      "referenceCaps": [
        19,
        21
      ],
      "requiredMargin": 32
    },
    "pillRule": "fixed reference geometry, centred word, family-wide reduction only; never enlarge a word to occupy the pill",
    "nameOverflow": "PROPOSAL: preserve measured reference cap, ellipsis in the measured lane. Also applies to example names that exceed the lane with Nunito. Second line needs owner direction.",
    "ctaException": "Explicit Nunito 800 56 with .01em tracking overrides reference cap. It cannot retain the old margins at reference width; see deviations. Plane omitted, as allowed by brief clause 1."
  },
  "popup": {
    "dim": {
      "color": "#000000",
      "opacity": 0.5,
      "x": 0,
      "y": 0,
      "w": 941,
      "h": 1672,
      "pointerEvents": "none",
      "z": 100
    },
    "roster": {
      "live": true,
      "transform": "none in the application",
      "referenceBand": {
        "x": 0,
        "y": 230,
        "w": 941,
        "h": 138
      },
      "currentGameBand": {
        "x": 0,
        "y": 284,
        "w": 941,
        "h": 175
      },
      "currentHits": {
        "x": 38.5,
        "y": 296,
        "pitch": 144,
        "w": 144,
        "h": 160,
        "count": 6
      },
      "zOrder": "dim above roster artwork; roster hit targets above backdrop catcher; title is non-interactive",
      "comparisonFixture": "Round-10 board registration: first 456 pixels mapped to 359, remainder to 1313. Comparison PNGs retain this historical fixture. It is not a runtime transformation.",
      "currentGameConflict": "Untouched current roster extends to y=459; reference title occupies y=370..452. Cannot satisfy both without a placement decision. Separate live-board-conflict preview supplied."
    },
    "groups": {
      "female": {
        "title": {
          "x": 102.225,
          "y": 358.663,
          "w": 739.989,
          "h": 108.674
        },
        "titleNeon": {
          "x": 118,
          "y": 374,
          "w": 708,
          "h": 78
        },
        "card": {
          "x": 44,
          "y": 445,
          "w": 856,
          "h": 1143
        },
        "cardNeon": {
          "x": 67,
          "y": 473,
          "w": 808,
          "h": 1092
        },
        "timer": {
          "x": 148.843,
          "y": 1569.236,
          "w": 642.708,
          "h": 97.528
        },
        "timerNeon": {
          "x": 163,
          "y": 1583,
          "w": 614,
          "h": 70
        },
        "bottomMarginNeon": 19,
        "bottomMarginIncludingGlow": 5.236,
        "untimed": {
          "translateX": 0,
          "translateY": 0,
          "title": {
            "x": 102.225,
            "y": 358.663,
            "w": 739.989,
            "h": 108.674
          },
          "card": {
            "x": 44,
            "y": 445,
            "w": 856,
            "h": 1143
          },
          "timerVisible": false,
          "bottomMarginNeon": 107
        },
        "titlePiece": "pill.large.png",
        "cardPiece": "pieces/card.base.female.png",
        "cardSlicePx": {
          "top": 332,
          "right": 126,
          "bottom": 197,
          "left": 126
        },
        "timerPiece": "pill.large.png",
        "clock": {
          "piece": "icon.clock",
          "x": 193,
          "y": 1597,
          "w": 41,
          "h": 41
        },
        "digitsLane": {
          "x": 689,
          "y": 1605,
          "w": 64,
          "h": 40
        },
        "track": {
          "piece": "pill.large.png",
          "x": 257.742,
          "y": 1598.888,
          "w": 422.663,
          "h": 36.225
        },
        "fill": {
          "piece": "cta.plate.png",
          "x": 258.996,
          "y": 1602.275,
          "w": 420.008,
          "h": 30.356,
          "clipRule": {
            "type": "inset",
            "right": "(1 - clamp(remainingMs / durationMs,0,1)) * 100%",
            "referenceFraction": 0.379,
            "referenceFillBox": {
              "x": 263,
              "y": 1606,
              "w": 156,
              "h": 23
            },
            "zero": "hide",
            "note": "full-width 3-slice rendered once; clip reveals left fraction; never squeeze either cap. Right clipping edge is straight and differs from reference."
          }
        }
      },
      "male": {
        "title": {
          "x": 103.831,
          "y": 355.253,
          "w": 731.758,
          "h": 104.494
        },
        "titleNeon": {
          "x": 119,
          "y": 370,
          "w": 701,
          "h": 75
        },
        "card": {
          "x": 41,
          "y": 443,
          "w": 857,
          "h": 1143
        },
        "cardNeon": {
          "x": 66,
          "y": 465,
          "w": 803,
          "h": 1077
        },
        "timer": {
          "x": 145.843,
          "y": 1548.236,
          "w": 641.708,
          "h": 97.528
        },
        "timerNeon": {
          "x": 160,
          "y": 1562,
          "w": 613,
          "h": 70
        },
        "bottomMarginNeon": 40,
        "bottomMarginIncludingGlow": 26.236,
        "untimed": {
          "translateX": 0,
          "translateY": 0,
          "title": {
            "x": 103.831,
            "y": 355.253,
            "w": 731.758,
            "h": 104.494
          },
          "card": {
            "x": 41,
            "y": 443,
            "w": 857,
            "h": 1143
          },
          "timerVisible": false,
          "bottomMarginNeon": 130
        },
        "titlePiece": "pill.large.png",
        "cardPiece": "pieces/card.base.male.png",
        "cardSlicePx": {
          "top": 332,
          "right": 126,
          "bottom": 198,
          "left": 126
        },
        "timerPiece": "pill.large.png",
        "clock": {
          "piece": "icon.clock",
          "x": 190,
          "y": 1578,
          "w": 40,
          "h": 40
        },
        "digitsLane": {
          "x": 684,
          "y": 1585,
          "w": 65,
          "h": 40
        },
        "track": {
          "piece": "pill.large.png",
          "x": 254.742,
          "y": 1579.888,
          "w": 420.663,
          "h": 36.225
        },
        "fill": {
          "piece": "cta.plate.png",
          "x": 255.822,
          "y": 1582.113,
          "w": 418.356,
          "h": 31.676,
          "clipRule": {
            "type": "inset",
            "right": "(1 - clamp(remainingMs / durationMs,0,1)) * 100%",
            "referenceFraction": 0.373,
            "referenceFillBox": {
              "x": 260,
              "y": 1586,
              "w": 153,
              "h": 24
            },
            "zero": "hide",
            "note": "full-width 3-slice rendered once; clip reveals left fraction; never squeeze either cap. Right clipping edge is straight and differs from reference."
          }
        }
      },
      "other": {
        "title": {
          "x": 102.831,
          "y": 355.253,
          "w": 733.758,
          "h": 104.494
        },
        "titleNeon": {
          "x": 118,
          "y": 370,
          "w": 703,
          "h": 75
        },
        "card": {
          "x": 43,
          "y": 446,
          "w": 852,
          "h": 1141
        },
        "cardNeon": {
          "x": 66,
          "y": 466,
          "w": 806,
          "h": 1077
        },
        "timer": {
          "x": 146.045,
          "y": 1548.433,
          "w": 641.298,
          "h": 96.135
        },
        "timerNeon": {
          "x": 160,
          "y": 1562,
          "w": 613,
          "h": 69
        },
        "bottomMarginNeon": 41,
        "bottomMarginIncludingGlow": 27.432,
        "untimed": {
          "translateX": 0,
          "translateY": 0,
          "title": {
            "x": 102.831,
            "y": 355.253,
            "w": 733.758,
            "h": 104.494
          },
          "card": {
            "x": 43,
            "y": 446,
            "w": 852,
            "h": 1141
          },
          "timerVisible": false,
          "bottomMarginNeon": 129
        },
        "titlePiece": "pill.large.png",
        "cardPiece": "pieces/card.base.other.png",
        "cardSlicePx": {
          "top": 330,
          "right": 126,
          "bottom": 197,
          "left": 126
        },
        "timerPiece": "pill.large.png",
        "clock": {
          "piece": "icon.clock",
          "x": 190,
          "y": 1577.5,
          "w": 40,
          "h": 40
        },
        "digitsLane": {
          "x": 685,
          "y": 1585,
          "w": 64,
          "h": 40
        },
        "track": {
          "piece": "pill.large.png",
          "x": 254.944,
          "y": 1580.084,
          "w": 421.253,
          "h": 34.831
        },
        "fill": {
          "piece": "cta.plate.png",
          "x": 255.648,
          "y": 1580.951,
          "w": 419.704,
          "h": 32.996,
          "clipRule": {
            "type": "inset",
            "right": "(1 - clamp(remainingMs / durationMs,0,1)) * 100%",
            "referenceFraction": 0.37,
            "referenceFillBox": {
              "x": 260,
              "y": 1585,
              "w": 152,
              "h": 25
            },
            "zero": "hide",
            "note": "full-width 3-slice rendered once; clip reveals left fraction; never squeeze either cap. Right clipping edge is straight and differs from reference."
          }
        }
      }
    },
    "fourLayerOrder": [
      "board including existing live roster artwork",
      "independent 50% black scrim",
      "title + card + timer surfaces",
      "live portraits, text, icons and hit targets"
    ],
    "printOrder": [
      "print.0.victory",
      "avatar.happy",
      "print.1.thinking",
      "print.2.flirt"
    ],
    "scroll": "none; fixed 941x1672 game stage"
  },
  "verification": {
    "wordFit": {
      "file": "preview/evidence/stage2-all-60-words.json",
      "count": 60,
      "themeChecks": 180,
      "size": 26.25,
      "referenceMinimum": 32,
      "minimum": 32,
      "pass": true
    },
    "alpha": {
      "pill.large.png": {
        "alpha": true,
        "range": [
          0,
          254
        ],
        "transparentPixels": 27877,
        "partialAlphaPixels": 161595
      },
      "create.pill.off": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 10422,
        "partialAlphaPixels": 24141
      },
      "cta.plate.png": {
        "alpha": true,
        "range": [
          0,
          254
        ],
        "transparentPixels": 56991,
        "partialAlphaPixels": 508945
      },
      "icon.clock": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 5146,
        "partialAlphaPixels": 908
      },
      "icon.paper-plane": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 32345,
        "partialAlphaPixels": 1310
      },
      "heart": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 15168,
        "partialAlphaPixels": 4252
      },
      "symbol.female": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 2404,
        "partialAlphaPixels": 8756
      },
      "symbol.male": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 4475,
        "partialAlphaPixels": 3866
      },
      "symbol.star": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 4681,
        "partialAlphaPixels": 3169
      },
      "close": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 20528,
        "partialAlphaPixels": 33151
      },
      "quote.open": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 26037,
        "partialAlphaPixels": 27622
      },
      "quote.close": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 25397,
        "partialAlphaPixels": 27284
      },
      "card.base.female": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 29522,
        "partialAlphaPixels": 948725
      },
      "avatar.female.happy": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 33639,
        "partialAlphaPixels": 31506
      },
      "avatar.female.victory": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 32455,
        "partialAlphaPixels": 32631
      },
      "avatar.female.thinking": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 37659,
        "partialAlphaPixels": 27500
      },
      "avatar.female.flirt": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 41425,
        "partialAlphaPixels": 23739
      },
      "card.base.male": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 47378,
        "partialAlphaPixels": 931953
      },
      "avatar.male.happy": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 37482,
        "partialAlphaPixels": 27664
      },
      "avatar.male.victory": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 34010,
        "partialAlphaPixels": 30961
      },
      "avatar.male.thinking": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 36901,
        "partialAlphaPixels": 28233
      },
      "avatar.male.flirt": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 39798,
        "partialAlphaPixels": 25320
      },
      "card.base.other": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 48008,
        "partialAlphaPixels": 924092
      },
      "avatar.other.happy": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 35774,
        "partialAlphaPixels": 29293
      },
      "avatar.other.victory": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 39228,
        "partialAlphaPixels": 25924
      },
      "avatar.other.thinking": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 38119,
        "partialAlphaPixels": 26985
      },
      "avatar.other.flirt": {
        "alpha": true,
        "range": [
          0,
          255
        ],
        "transparentPixels": 37175,
        "partialAlphaPixels": 27955
      },
      "print.1": {
        "alpha": true,
        "range": [
          255,
          255
        ],
        "transparentPixels": 0,
        "partialAlphaPixels": 0
      },
      "print.2": {
        "alpha": true,
        "range": [
          255,
          255
        ],
        "transparentPixels": 0,
        "partialAlphaPixels": 0
      },
      "print.3": {
        "alpha": true,
        "range": [
          255,
          255
        ],
        "transparentPixels": 0,
        "partialAlphaPixels": 0
      }
    },
    "hits": {
      "female": [
        {
          "id": "close",
          "w": 116,
          "h": 116,
          "css360": [
            44.378,
            44.378
          ],
          "css390": [
            48.077,
            48.077
          ],
          "pass": true
        },
        {
          "id": "send",
          "w": 435,
          "h": 126.28,
          "css360": [
            166.419,
            48.311
          ],
          "css390": [
            180.287,
            52.337
          ],
          "pass": true
        }
      ],
      "male": [
        {
          "id": "close",
          "w": 116,
          "h": 116,
          "css360": [
            44.378,
            44.378
          ],
          "css390": [
            48.077,
            48.077
          ],
          "pass": true
        },
        {
          "id": "send",
          "w": 433,
          "h": 126.28,
          "css360": [
            165.654,
            48.311
          ],
          "css390": [
            179.458,
            52.337
          ],
          "pass": true
        }
      ],
      "other": [
        {
          "id": "close",
          "w": 116,
          "h": 116,
          "css360": [
            44.378,
            44.378
          ],
          "css390": [
            48.077,
            48.077
          ],
          "pass": true
        },
        {
          "id": "send",
          "w": 435,
          "h": 126.28,
          "css360": [
            166.419,
            48.311
          ],
          "css390": [
            180.287,
            52.337
          ],
          "pass": true
        }
      ]
    },
    "type": {
      "female": {
        "type": [
          {
            "id": "title",
            "text": "WHAT WOULD SAMANTHA ANSWER?",
            "size": 26.25,
            "initialSize": 28.75,
            "referenceCap": 21,
            "actualCap": 18,
            "inkW": 493,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "name",
            "text": "Samantha",
            "size": 102.5,
            "initialSize": 102.5,
            "referenceCap": 75,
            "actualCap": 75,
            "inkW": 495,
            "inkH": 75,
            "css360": 39.214,
            "css390": 42.481,
            "decor": false
          },
          {
            "id": "age",
            "text": "23",
            "size": 118.25,
            "initialSize": 128.75,
            "referenceCap": 93,
            "actualCap": 84,
            "inkW": 132,
            "inkH": 87,
            "css360": 45.239,
            "css390": 49.009,
            "decor": false
          },
          {
            "id": "country",
            "text": "Spain",
            "size": 35.25,
            "initialSize": 38.5,
            "referenceCap": 28,
            "actualCap": 25,
            "inkW": 90,
            "inkH": 33,
            "css360": 13.486,
            "css390": 14.609,
            "decor": false
          },
          {
            "id": "city",
            "text": "Madrid",
            "size": 26.5,
            "initialSize": 28.75,
            "referenceCap": 20,
            "actualCap": 19,
            "inkW": 83,
            "inkH": 20,
            "css360": 10.138,
            "css390": 10.983,
            "decor": false
          },
          {
            "id": "tag.0.word",
            "text": "Sociable",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 18,
            "inkW": 101,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.1.word",
            "text": "Curious",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 18,
            "inkW": 90,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.2.word",
            "text": "Generous",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 19,
            "inkW": 114,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.3.word",
            "text": "Playful",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 19,
            "inkW": 84,
            "inkH": 24,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.4.word",
            "text": "Selective",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 18,
            "inkW": 108,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.5.word",
            "text": "Spontaneous",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 18,
            "inkW": 157,
            "inkH": 24,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "bio.0",
            "text": "Chaos, chemistry, and late-night laughs.",
            "size": 23.5,
            "initialSize": 23.5,
            "referenceCap": 19,
            "actualCap": 16,
            "inkW": 428,
            "inkH": 22,
            "css360": 8.99,
            "css390": 9.74,
            "decor": false
          },
          {
            "id": "bio.1",
            "text": "I love deep talks and even deeper connections.",
            "size": 23.5,
            "initialSize": 23.5,
            "referenceCap": 18,
            "actualCap": 16,
            "inkW": 495,
            "inkH": 22,
            "css360": 8.99,
            "css390": 9.74,
            "decor": false
          },
          {
            "id": "send.label",
            "text": "Send Message",
            "size": 56,
            "initialSize": 56,
            "referenceCap": 26,
            "actualCap": 40,
            "inkW": 384,
            "inkH": 52,
            "css360": 21.424,
            "css390": 23.209,
            "decor": false
          },
          {
            "id": "timer.digits",
            "text": "5s",
            "size": 25.25,
            "initialSize": 36.75,
            "referenceCap": 26,
            "actualCap": 19,
            "inkW": 26,
            "inkH": 19,
            "css360": 9.66,
            "css390": 10.465,
            "decor": false
          }
        ],
        "bio": {
          "lane": {
            "x": 222,
            "y": 1286,
            "w": 496,
            "h": 63
          },
          "fontSize": 23.5,
          "linePitch": 32,
          "typicalSample": "The quick brown fox jumps over the lazy dog. I love deep talks and late-night laughs.",
          "typicalMeanAdvance": 10.688,
          "typicalCharsPerLine": 46,
          "typicalTwoLineChars": 92,
          "widestGlyph": "W",
          "widestGlyphCodepoint": "U+57",
          "widestAdvance": 26.015,
          "testedCodepoints": 228,
          "widestCharsPerLine": 19,
          "widestTwoLineChars": 38,
          "wrap": "word wrap, fallback break-word for long tokens; clamp to two lines with ellipsis; capacity is glyph-dependent, not a universal maxLength. Widest covers every mapped codepoint of this Nunito subset, not fallback fonts."
        },
        "name": {
          "full": "Samantha",
          "referenceWidth": 374,
          "fullInkWidth": 495,
          "size": 102.5,
          "cap": 75,
          "overflow": true,
          "display": "Sama…"
        },
        "cta": {
          "box": {
            "x": 252,
            "y": 1381.86,
            "w": 435,
            "h": 126.28
          },
          "fontSize": 56,
          "weight": 800,
          "trackingEm": 0.01,
          "wordInkWidth": 384,
          "wordAdvance": 387.184,
          "boxMargin": 25.5,
          "neonMargin": 8.843,
          "referenceGroupMargin": {
            "left": 59,
            "right": 64
          },
          "withPlaneWidth": 466,
          "wordShift": 0,
          "marginPass": false
        }
      },
      "male": {
        "type": [
          {
            "id": "title",
            "text": "WHAT WOULD WILHELMI ANSWER?",
            "size": 26.25,
            "initialSize": 30.25,
            "referenceCap": 22,
            "actualCap": 18,
            "inkW": 472,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "name",
            "text": "Wilhelmi",
            "size": 99,
            "initialSize": 99,
            "referenceCap": 72,
            "actualCap": 72,
            "inkW": 438,
            "inkH": 76,
            "css360": 37.875,
            "css390": 41.031,
            "decor": false
          },
          {
            "id": "age",
            "text": "24",
            "size": 120.25,
            "initialSize": 130.75,
            "referenceCap": 95,
            "actualCap": 86,
            "inkW": 139,
            "inkH": 88,
            "css360": 46.004,
            "css390": 49.838,
            "decor": false
          },
          {
            "id": "country",
            "text": "Germany",
            "size": 36.5,
            "initialSize": 39.75,
            "referenceCap": 29,
            "actualCap": 27,
            "inkW": 154,
            "inkH": 34,
            "css360": 13.964,
            "css390": 15.128,
            "decor": false
          },
          {
            "id": "city",
            "text": "Berlin",
            "size": 28,
            "initialSize": 30.25,
            "referenceCap": 22,
            "actualCap": 20,
            "inkW": 75,
            "inkH": 21,
            "css360": 10.712,
            "css390": 11.605,
            "decor": false
          },
          {
            "id": "tag.0.word",
            "text": "Observer",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 20,
            "actualCap": 19,
            "inkW": 111,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.1.word",
            "text": "Curious",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 20,
            "actualCap": 18,
            "inkW": 90,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.2.word",
            "text": "Investor",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 20,
            "actualCap": 21,
            "inkW": 96,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.3.word",
            "text": "Logical",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 20,
            "actualCap": 19,
            "inkW": 85,
            "inkH": 24,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.4.word",
            "text": "Reserved",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 19,
            "actualCap": 19,
            "inkW": 109,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.5.word",
            "text": "Night owl",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 20,
            "actualCap": 19,
            "inkW": 118,
            "inkH": 24,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "bio.0",
            "text": "Quiet charm, late-night thoughts, and a sharp",
            "size": 19,
            "initialSize": 19,
            "referenceCap": 17,
            "actualCap": 17,
            "inkW": 394,
            "inkH": 18,
            "css360": 7.269,
            "css390": 7.875,
            "decor": false
          },
          {
            "id": "bio.1",
            "text": "eye for details. I open up slowly, but I mean it when I do.",
            "size": 19,
            "initialSize": 19,
            "referenceCap": 15,
            "actualCap": 10,
            "inkW": 484,
            "inkH": 18,
            "css360": 7.269,
            "css390": 7.875,
            "decor": false
          },
          {
            "id": "send.label",
            "text": "Send Message",
            "size": 56,
            "initialSize": 56,
            "referenceCap": 26,
            "actualCap": 40,
            "inkW": 384,
            "inkH": 52,
            "css360": 21.424,
            "css390": 23.209,
            "decor": false
          },
          {
            "id": "timer.digits",
            "text": "5s",
            "size": 25.25,
            "initialSize": 37.5,
            "referenceCap": 27,
            "actualCap": 19,
            "inkW": 26,
            "inkH": 19,
            "css360": 9.66,
            "css390": 10.465,
            "decor": false
          }
        ],
        "bio": {
          "lane": {
            "x": 220,
            "y": 1271,
            "w": 493,
            "h": 62
          },
          "fontSize": 19,
          "linePitch": 29,
          "typicalSample": "The quick brown fox jumps over the lazy dog. I love deep talks and late-night laughs.",
          "typicalMeanAdvance": 8.642,
          "typicalCharsPerLine": 57,
          "typicalTwoLineChars": 114,
          "widestGlyph": "W",
          "widestGlyphCodepoint": "U+57",
          "widestAdvance": 21.033,
          "testedCodepoints": 228,
          "widestCharsPerLine": 23,
          "widestTwoLineChars": 46,
          "wrap": "word wrap, fallback break-word for long tokens; clamp to two lines with ellipsis; capacity is glyph-dependent, not a universal maxLength. Widest covers every mapped codepoint of this Nunito subset, not fallback fonts."
        },
        "name": {
          "full": "Wilhelmi",
          "referenceWidth": 353,
          "fullInkWidth": 438,
          "size": 99,
          "cap": 72,
          "overflow": true,
          "display": "Wilh…"
        },
        "cta": {
          "box": {
            "x": 249,
            "y": 1360.86,
            "w": 433,
            "h": 126.28
          },
          "fontSize": 56,
          "weight": 800,
          "trackingEm": 0.01,
          "wordInkWidth": 384,
          "wordAdvance": 387.184,
          "boxMargin": 24.5,
          "neonMargin": 7.843,
          "referenceGroupMargin": {
            "left": 60,
            "right": 66
          },
          "withPlaneWidth": 466,
          "wordShift": 0,
          "marginPass": false
        }
      },
      "other": {
        "type": [
          {
            "id": "title",
            "text": "WHAT WOULD ALEXANDRIELLE ANSWER?",
            "size": 26.25,
            "initialSize": 30.25,
            "referenceCap": 22,
            "actualCap": 18,
            "inkW": 553,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "name",
            "text": "Alexandrielle",
            "size": 86.5,
            "initialSize": 86.5,
            "referenceCap": 63,
            "actualCap": 63,
            "inkW": 563,
            "inkH": 66,
            "css360": 33.092,
            "css390": 35.85,
            "decor": false
          },
          {
            "id": "age",
            "text": "23",
            "size": 113.75,
            "initialSize": 123.75,
            "referenceCap": 90,
            "actualCap": 82,
            "inkW": 128,
            "inkH": 84,
            "css360": 43.518,
            "css390": 47.144,
            "decor": false
          },
          {
            "id": "country",
            "text": "Canada",
            "size": 36.5,
            "initialSize": 39.75,
            "referenceCap": 29,
            "actualCap": 27,
            "inkW": 126,
            "inkH": 27,
            "css360": 13.964,
            "css390": 15.128,
            "decor": false
          },
          {
            "id": "city",
            "text": "Toronto",
            "size": 30.5,
            "initialSize": 33,
            "referenceCap": 24,
            "actualCap": 22,
            "inkW": 110,
            "inkH": 22,
            "css360": 11.668,
            "css390": 12.641,
            "decor": false
          },
          {
            "id": "tag.0.word",
            "text": "Team player",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 19,
            "inkW": 149,
            "inkH": 24,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.1.word",
            "text": "Curious",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 18,
            "inkW": 90,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.2.word",
            "text": "Collector",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 21,
            "actualCap": 18,
            "inkW": 109,
            "inkH": 20,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.3.word",
            "text": "Playful",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 20,
            "actualCap": 19,
            "inkW": 84,
            "inkH": 24,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.4.word",
            "text": "Expressive",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 20,
            "actualCap": 19,
            "inkW": 127,
            "inkH": 24,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "tag.5.word",
            "text": "Night owl",
            "size": 26.25,
            "initialSize": 26.25,
            "referenceCap": 20,
            "actualCap": 19,
            "inkW": 118,
            "inkH": 24,
            "css360": 10.043,
            "css390": 10.879,
            "decor": false
          },
          {
            "id": "bio.0",
            "text": "Soft chaos, late-night spark, and a heart full of stories.",
            "size": 19.75,
            "initialSize": 19.75,
            "referenceCap": 15,
            "actualCap": 15,
            "inkW": 494,
            "inkH": 19,
            "css360": 7.556,
            "css390": 8.185,
            "decor": false
          },
          {
            "id": "bio.1",
            "text": "Easy to meet, hard to forget.",
            "size": 19.75,
            "initialSize": 19.75,
            "referenceCap": 15,
            "actualCap": 15,
            "inkW": 256,
            "inkH": 19,
            "css360": 7.556,
            "css390": 8.185,
            "decor": false
          },
          {
            "id": "send.label",
            "text": "Send Message",
            "size": 56,
            "initialSize": 56,
            "referenceCap": 27,
            "actualCap": 40,
            "inkW": 384,
            "inkH": 52,
            "css360": 21.424,
            "css390": 23.209,
            "decor": false
          },
          {
            "id": "timer.digits",
            "text": "5s",
            "size": 25.25,
            "initialSize": 37.5,
            "referenceCap": 27,
            "actualCap": 19,
            "inkW": 26,
            "inkH": 19,
            "css360": 9.66,
            "css390": 10.465,
            "decor": false
          }
        ],
        "bio": {
          "lane": {
            "x": 219,
            "y": 1272,
            "w": 497,
            "h": 59
          },
          "fontSize": 19.75,
          "linePitch": 29,
          "typicalSample": "The quick brown fox jumps over the lazy dog. I love deep talks and late-night laughs.",
          "typicalMeanAdvance": 9.096,
          "typicalCharsPerLine": 54,
          "typicalTwoLineChars": 108,
          "widestGlyph": "W",
          "widestGlyphCodepoint": "U+57",
          "widestAdvance": 22.14,
          "testedCodepoints": 228,
          "widestCharsPerLine": 22,
          "widestTwoLineChars": 44,
          "wrap": "word wrap, fallback break-word for long tokens; clamp to two lines with ellipsis; capacity is glyph-dependent, not a universal maxLength. Widest covers every mapped codepoint of this Nunito subset, not fallback fonts."
        },
        "name": {
          "full": "Alexandrielle",
          "referenceWidth": 414,
          "fullInkWidth": 563,
          "size": 86.5,
          "cap": 63,
          "overflow": true,
          "display": "Alexan…"
        },
        "cta": {
          "box": {
            "x": 248,
            "y": 1358.86,
            "w": 435,
            "h": 126.28
          },
          "fontSize": 56,
          "weight": 800,
          "trackingEm": 0.01,
          "wordInkWidth": 384,
          "wordAdvance": 387.184,
          "boxMargin": 25.5,
          "neonMargin": 8.843,
          "referenceGroupMargin": {
            "left": 61,
            "right": 65
          },
          "withPlaneWidth": 466,
          "wordShift": 0,
          "marginPass": false
        }
      }
    },
    "familyFits": {
      "title": {
        "initialSizes": [
          28.75,
          30.25,
          30.25
        ],
        "finalSizes": [
          26.25,
          26.25,
          26.25
        ],
        "rule": "all three theme instances share the same reduction; common families also share one absolute size",
        "fitWidthByTheme": {
          "female": 580,
          "male": 573,
          "other": 575
        }
      },
      "age": {
        "initialSizes": [
          128.75,
          130.75,
          123.75
        ],
        "finalSizes": [
          118.25,
          120.25,
          113.75
        ],
        "rule": "all three theme instances share the same reduction; common families also share one absolute size",
        "fitWidthByTheme": {
          "female": 134,
          "male": 139,
          "other": 137
        }
      },
      "country": {
        "initialSizes": [
          38.5,
          39.75,
          39.75
        ],
        "finalSizes": [
          35.25,
          36.5,
          36.5
        ],
        "rule": "all three theme instances share the same reduction; common families also share one absolute size",
        "fitWidthByTheme": {
          "female": 93,
          "male": 160,
          "other": 127
        }
      },
      "city": {
        "initialSizes": [
          28.75,
          30.25,
          33
        ],
        "finalSizes": [
          26.5,
          28,
          30.5
        ],
        "rule": "all three theme instances share the same reduction; common families also share one absolute size",
        "fitWidthByTheme": {
          "female": 87,
          "male": 79,
          "other": 111
        }
      },
      "timer.digits": {
        "initialSizes": [
          36.75,
          37.5,
          37.5
        ],
        "finalSizes": [
          25.25,
          25.25,
          25.25
        ],
        "rule": "all three theme instances share the same reduction; common families also share one absolute size",
        "fitWidthByTheme": {
          "female": 56,
          "male": 57,
          "other": 56
        }
      }
    },
    "bioCapacity": {
      "female": {
        "lane": {
          "x": 222,
          "y": 1286,
          "w": 496,
          "h": 63
        },
        "fontSize": 23.5,
        "linePitch": 32,
        "typicalSample": "The quick brown fox jumps over the lazy dog. I love deep talks and late-night laughs.",
        "typicalMeanAdvance": 10.688,
        "typicalCharsPerLine": 46,
        "typicalTwoLineChars": 92,
        "widestGlyph": "W",
        "widestGlyphCodepoint": "U+57",
        "widestAdvance": 26.015,
        "testedCodepoints": 228,
        "widestCharsPerLine": 19,
        "widestTwoLineChars": 38,
        "wrap": "word wrap, fallback break-word for long tokens; clamp to two lines with ellipsis; capacity is glyph-dependent, not a universal maxLength. Widest covers every mapped codepoint of this Nunito subset, not fallback fonts."
      },
      "male": {
        "lane": {
          "x": 220,
          "y": 1271,
          "w": 493,
          "h": 62
        },
        "fontSize": 19,
        "linePitch": 29,
        "typicalSample": "The quick brown fox jumps over the lazy dog. I love deep talks and late-night laughs.",
        "typicalMeanAdvance": 8.642,
        "typicalCharsPerLine": 57,
        "typicalTwoLineChars": 114,
        "widestGlyph": "W",
        "widestGlyphCodepoint": "U+57",
        "widestAdvance": 21.033,
        "testedCodepoints": 228,
        "widestCharsPerLine": 23,
        "widestTwoLineChars": 46,
        "wrap": "word wrap, fallback break-word for long tokens; clamp to two lines with ellipsis; capacity is glyph-dependent, not a universal maxLength. Widest covers every mapped codepoint of this Nunito subset, not fallback fonts."
      },
      "other": {
        "lane": {
          "x": 219,
          "y": 1272,
          "w": 497,
          "h": 59
        },
        "fontSize": 19.75,
        "linePitch": 29,
        "typicalSample": "The quick brown fox jumps over the lazy dog. I love deep talks and late-night laughs.",
        "typicalMeanAdvance": 9.096,
        "typicalCharsPerLine": 54,
        "typicalTwoLineChars": 108,
        "widestGlyph": "W",
        "widestGlyphCodepoint": "U+57",
        "widestAdvance": 22.14,
        "testedCodepoints": 228,
        "widestCharsPerLine": 22,
        "widestTwoLineChars": 44,
        "wrap": "word wrap, fallback break-word for long tokens; clamp to two lines with ellipsis; capacity is glyph-dependent, not a universal maxLength. Widest covers every mapped codepoint of this Nunito subset, not fallback fonts."
      }
    },
    "fourLayerOrder": {
      "pass": true,
      "order": [
        "board including existing live roster artwork",
        "independent 50% black scrim",
        "title + card + timer surfaces",
        "live portraits, text, icons and hit targets"
      ],
      "portraitOrder": [
        "print.0.victory",
        "avatar.happy",
        "print.1.thinking",
        "print.2.flirt"
      ]
    },
    "bottomMargins": {
      "female": {
        "neon": 19,
        "includingGlow": 5.236,
        "untimed": 107
      },
      "male": {
        "neon": 40,
        "includingGlow": 26.236,
        "untimed": 130
      },
      "other": {
        "neon": 41,
        "includingGlow": 27.432,
        "untimed": 129
      }
    },
    "mobileTextFloors": {
      "pass": false,
      "reason": "The stage-2 instruction preserves reference cap heights and family margins; several fonts are below older 14/16 CSS px floors at 360. Values listed per family. No hidden mobile enlargement."
    },
    "roster": {
      "referenceFixtureOverlap": false,
      "currentUntouchedBoardOverlap": true,
      "referenceBand": {
        "x": 0,
        "y": 230,
        "w": 941,
        "h": 138
      },
      "currentBand": {
        "x": 0,
        "y": 284,
        "w": 941,
        "h": 175
      },
      "decisionNeeded": "Reference title and untouched current GameRoster cannot share the same vertical band."
    },
    "previewEvidence": "preview/evidence/stage4-render-audit.json",
    "overlaps": {
      "female": {
        "ageToDivider": 19,
        "nameToUpperPrint": 41.287,
        "titleToCardNeon": 21,
        "tagColumnGaps": [
          13,
          14
        ],
        "tagRowGap": 13,
        "tagsToBio": 34,
        "bioToSendOuter": 21.86,
        "sendOuterToCardNeonBottom": 56.86,
        "cardToTimerNeon": 18,
        "currentRosterTitleConflict": true,
        "intentional": [
          "portrait behind upper tag row",
          "upper print behind portrait",
          "second and third prints over portrait",
          "overlapping photo papers",
          "capsule and card glows overlap while neon contours stay separate"
        ],
        "paperCornerMatch": "upright rectangular complete plate; uniform whole-image scale; no source slicing"
      },
      "male": {
        "ageToDivider": 14,
        "nameToUpperPrint": 80.601,
        "titleToCardNeon": 20,
        "tagColumnGaps": [
          14,
          13
        ],
        "tagRowGap": 14,
        "tagsToBio": 35,
        "bioToSendOuter": 18.86,
        "sendOuterToCardNeonBottom": 54.86,
        "cardToTimerNeon": 20,
        "currentRosterTitleConflict": true,
        "intentional": [
          "portrait behind upper tag row",
          "upper print behind portrait",
          "second and third prints over portrait",
          "overlapping photo papers",
          "capsule and card glows overlap while neon contours stay separate"
        ],
        "paperCornerMatch": "upright rectangular complete plate; uniform whole-image scale; no source slicing"
      },
      "other": {
        "ageToDivider": 23,
        "nameToUpperPrint": 55.8,
        "titleToCardNeon": 21,
        "tagColumnGaps": [
          14,
          14
        ],
        "tagRowGap": 12,
        "tagsToBio": 25,
        "bioToSendOuter": 17.86,
        "sendOuterToCardNeonBottom": 57.86,
        "cardToTimerNeon": 19,
        "currentRosterTitleConflict": true,
        "intentional": [
          "portrait behind upper tag row",
          "upper print behind portrait",
          "second and third prints over portrait",
          "overlapping photo papers",
          "capsule and card glows overlap while neon contours stay separate"
        ],
        "paperCornerMatch": "upright rectangular complete plate; uniform whole-image scale; no source slicing"
      }
    },
    "textFits": {
      "female": [
        {
          "id": "title",
          "display": "WHAT WOULD SAMANTHA ANSWER?",
          "inkBox": "225.5, 402, 493, 20",
          "lane": "182, 402, 580, 45",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 421
        },
        {
          "id": "name",
          "display": "Sama…",
          "inkBox": "112, 610, 352, 75",
          "lane": "112, 610, 374, 76",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 683.5
        },
        {
          "id": "age",
          "display": "23",
          "inkBox": "114, 728, 132, 87",
          "lane": "114, 728, 134, 95",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 813
        },
        {
          "id": "country",
          "display": "Spain",
          "inkBox": "195, 858, 90, 33",
          "lane": "195, 858, 93, 36",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 884
        },
        {
          "id": "city",
          "display": "Madrid",
          "inkBox": "159, 919, 83, 20",
          "lane": "159, 919, 87, 22",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 938.5
        },
        {
          "id": "tag.0.word",
          "display": "Sociable",
          "inkBox": "185.5, 1096, 101, 20",
          "lane": "154, 1070, 164, 72",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1115
        },
        {
          "id": "tag.1.word",
          "display": "Curious",
          "inkBox": "426.5, 1096, 90, 20",
          "lane": "395, 1070, 153, 72",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1115
        },
        {
          "id": "tag.2.word",
          "display": "Generous",
          "inkBox": "650, 1096, 114, 20",
          "lane": "626, 1070, 162, 72",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1115
        },
        {
          "id": "tag.3.word",
          "display": "Playful",
          "inkBox": "193.5, 1179, 84, 24",
          "lane": "154, 1155, 163, 72",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1198
        },
        {
          "id": "tag.4.word",
          "display": "Selective",
          "inkBox": "418, 1180, 108, 20",
          "lane": "395, 1154, 154, 72",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1199
        },
        {
          "id": "tag.5.word",
          "display": "Spontaneous",
          "inkBox": "629, 1179, 157, 24",
          "lane": "627, 1155, 161, 72",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1198
        },
        {
          "id": "bio.0",
          "display": "Chaos, chemistry, and late-night laughs.",
          "inkBox": "256, 1286, 428, 22",
          "lane": "222, 1286, 496, 32",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1303
        },
        {
          "id": "bio.1",
          "display": "I love deep talks and even deeper connections.",
          "inkBox": "222.5, 1318, 495, 22",
          "lane": "222, 1318, 496, 32",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1335
        },
        {
          "id": "send.label",
          "display": "Send Message",
          "inkBox": "277.5, 1419, 384, 52",
          "lane": "252, 1381.86, 435, 126.28",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1459.5
        },
        {
          "id": "timer.digits",
          "display": "5s",
          "inkBox": "708, 1608.5, 26, 19",
          "lane": "689, 1605, 64, 40",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1626.5
        }
      ],
      "male": [
        {
          "id": "title",
          "display": "WHAT WOULD WILHELMI ANSWER?",
          "inkBox": "233.5, 396, 472, 20",
          "lane": "183, 396, 573, 45",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 415
        },
        {
          "id": "name",
          "display": "Wilh…",
          "inkBox": "108, 606, 313, 76",
          "lane": "108, 606, 353, 76",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 680
        },
        {
          "id": "age",
          "display": "24",
          "inkBox": "111, 715, 139, 88",
          "lane": "111, 715, 139, 95",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 801
        },
        {
          "id": "country",
          "display": "Germany",
          "inkBox": "190, 842, 154, 34",
          "lane": "190, 842, 160, 37",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 868.5
        },
        {
          "id": "city",
          "display": "Berlin",
          "inkBox": "163, 903, 75, 21",
          "lane": "163, 903, 79, 23",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 923.5
        },
        {
          "id": "tag.0.word",
          "display": "Observer",
          "inkBox": "178, 1080, 111, 20",
          "lane": "153, 1055, 161, 70",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1099
        },
        {
          "id": "tag.1.word",
          "display": "Curious",
          "inkBox": "423.5, 1080, 90, 20",
          "lane": "392, 1055, 153, 70",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1099
        },
        {
          "id": "tag.2.word",
          "display": "Investor",
          "inkBox": "654.5, 1080, 96, 20",
          "lane": "622, 1055, 161, 70",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1099
        },
        {
          "id": "tag.3.word",
          "display": "Logical",
          "inkBox": "191.5, 1162, 85, 24",
          "lane": "154, 1139, 160, 70",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1181
        },
        {
          "id": "tag.4.word",
          "display": "Reserved",
          "inkBox": "414, 1164, 109, 20",
          "lane": "392, 1139, 153, 70",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1183
        },
        {
          "id": "tag.5.word",
          "display": "Night owl",
          "inkBox": "644.5, 1162, 118, 24",
          "lane": "624, 1139, 159, 70",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1181
        },
        {
          "id": "bio.0",
          "display": "Quiet charm, late-night thoughts, and a sharp",
          "inkBox": "269.5, 1271, 394, 18",
          "lane": "220, 1271, 493, 29",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1285
        },
        {
          "id": "bio.1",
          "display": "eye for details. I open up slowly, but I mean it when I do.",
          "inkBox": "224.5, 1300, 484, 18",
          "lane": "220, 1300, 493, 29",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1314
        },
        {
          "id": "send.label",
          "display": "Send Message",
          "inkBox": "273.5, 1398, 384, 52",
          "lane": "249, 1360.86, 433, 126.28",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1438.5
        },
        {
          "id": "timer.digits",
          "display": "5s",
          "inkBox": "703.5, 1589, 26, 19",
          "lane": "684, 1585, 65, 40",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1607
        }
      ],
      "other": [
        {
          "id": "title",
          "display": "WHAT WOULD ALEXANDRIELLE ANSWER?",
          "inkBox": "193, 397, 553, 20",
          "lane": "182, 397, 575, 45",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 416
        },
        {
          "id": "name",
          "display": "Alexan…",
          "inkBox": "101, 601, 361, 63",
          "lane": "101, 601, 414, 68",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 663
        },
        {
          "id": "age",
          "display": "23",
          "inkBox": "113, 702, 128, 84",
          "lane": "113, 702, 137, 92",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 784
        },
        {
          "id": "country",
          "display": "Canada",
          "inkBox": "192, 815, 126, 27",
          "lane": "192, 815, 127, 30",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 841.5
        },
        {
          "id": "city",
          "display": "Toronto",
          "inkBox": "156, 876, 110, 22",
          "lane": "156, 876, 111, 24",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 897.5
        },
        {
          "id": "tag.0.word",
          "display": "Team player",
          "inkBox": "159, 1096.5, 149, 24",
          "lane": "153, 1075, 161, 67",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1115.5
        },
        {
          "id": "tag.1.word",
          "display": "Curious",
          "inkBox": "423.5, 1098.5, 90, 20",
          "lane": "392, 1075, 153, 67",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1117.5
        },
        {
          "id": "tag.2.word",
          "display": "Collector",
          "inkBox": "648.5, 1098.5, 109, 20",
          "lane": "623, 1075, 160, 67",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1117.5
        },
        {
          "id": "tag.3.word",
          "display": "Playful",
          "inkBox": "191.5, 1175.5, 84, 24",
          "lane": "153, 1154, 161, 67",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1194.5
        },
        {
          "id": "tag.4.word",
          "display": "Expressive",
          "inkBox": "405, 1175.5, 127, 24",
          "lane": "392, 1154, 153, 67",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1194.5
        },
        {
          "id": "tag.5.word",
          "display": "Night owl",
          "inkBox": "644.5, 1175.5, 118, 24",
          "lane": "623, 1154, 161, 67",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1194.5
        },
        {
          "id": "bio.0",
          "display": "Soft chaos, late-night spark, and a heart full of stories.",
          "inkBox": "220.5, 1272, 494, 19",
          "lane": "219, 1272, 497, 29",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1286.5
        },
        {
          "id": "bio.1",
          "display": "Easy to meet, hard to forget.",
          "inkBox": "339.5, 1301, 256, 19",
          "lane": "219, 1301, 497, 29",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1315.5
        },
        {
          "id": "send.label",
          "display": "Send Message",
          "inkBox": "273.5, 1396, 384, 52",
          "lane": "248, 1358.86, 435, 126.28",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1436.5
        },
        {
          "id": "timer.digits",
          "display": "5s",
          "inkBox": "704, 1589, 26, 19",
          "lane": "685, 1585, 64, 40",
          "outsideHorizontal": 0,
          "fits": true,
          "baseline": 1607
        }
      ]
    },
    "audit": "preview/evidence/stage4-verification.json",
    "previousAudit": {
      "file": "preview/evidence/stage2-verification.json",
      "scope": "historical stage-2 full-card audit; does not verify the stage-4 prints"
    },
    "mechanicalPass": true,
    "stage4": {
      "audit": "preview/evidence/stage4-verification.json",
      "pass": true,
      "checksPassed": 217,
      "checksTotal": 217
    }
  },
  "deviations": [
    {
      "id": "cta-margin",
      "status": "CONFLICT",
      "detail": "Required 56px word on reference-width Crew plate leaves only 8–9 stage units to the neon, instead of reference 59–66. The optional plane is omitted. Width, height, font and asset follow clause 1; OD-044 margin cannot also pass.",
      "values": {
        "female": {
          "box": {
            "x": 252,
            "y": 1381.86,
            "w": 435,
            "h": 126.28
          },
          "fontSize": 56,
          "weight": 800,
          "trackingEm": 0.01,
          "wordInkWidth": 384,
          "wordAdvance": 387.184,
          "boxMargin": 25.5,
          "neonMargin": 8.843,
          "referenceGroupMargin": {
            "left": 59,
            "right": 64
          },
          "withPlaneWidth": 466,
          "wordShift": 0,
          "marginPass": false
        },
        "male": {
          "box": {
            "x": 249,
            "y": 1360.86,
            "w": 433,
            "h": 126.28
          },
          "fontSize": 56,
          "weight": 800,
          "trackingEm": 0.01,
          "wordInkWidth": 384,
          "wordAdvance": 387.184,
          "boxMargin": 24.5,
          "neonMargin": 7.843,
          "referenceGroupMargin": {
            "left": 60,
            "right": 66
          },
          "withPlaneWidth": 466,
          "wordShift": 0,
          "marginPass": false
        },
        "other": {
          "box": {
            "x": 248,
            "y": 1358.86,
            "w": 435,
            "h": 126.28
          },
          "fontSize": 56,
          "weight": 800,
          "trackingEm": 0.01,
          "wordInkWidth": 384,
          "wordAdvance": 387.184,
          "boxMargin": 25.5,
          "neonMargin": 8.843,
          "referenceGroupMargin": {
            "left": 61,
            "right": 65
          },
          "withPlaneWidth": 466,
          "wordShift": 0,
          "marginPass": false
        }
      },
      "ownerDecision": "smaller shared CTA font would restore margin; not applied because exact 56 is explicit"
    },
    {
      "id": "name-overflow",
      "status": "PROPOSAL",
      "detail": "Nunito at reference caps is wider than the generated reference lettering. Ellipsis shown in the measured name lane, even for an example that overflows. No shrinking.",
      "values": {
        "female": {
          "full": "Samantha",
          "referenceWidth": 374,
          "fullInkWidth": 495,
          "size": 102.5,
          "cap": 75,
          "overflow": true,
          "display": "Sama…"
        },
        "male": {
          "full": "Wilhelmi",
          "referenceWidth": 353,
          "fullInkWidth": 438,
          "size": 99,
          "cap": 72,
          "overflow": true,
          "display": "Wilh…"
        },
        "other": {
          "full": "Alexandrielle",
          "referenceWidth": 414,
          "fullInkWidth": 563,
          "size": 86.5,
          "cap": 63,
          "overflow": true,
          "display": "Alexan…"
        }
      }
    },
    {
      "id": "roster-title",
      "status": "CONFLICT",
      "detail": "Untouched current roster extends to y=459; reference title occupies y=370..452. Cannot satisfy both without a placement decision. Separate live-board-conflict preview supplied.",
      "proof": "preview/stage2-live-board-conflict-941.png"
    },
    {
      "id": "base-art",
      "status": "RETAINED",
      "detail": "Existing round-10 bases retained byte-for-byte. Palms, corner shapes, glow, some decorations and inner line still differ from the references. Native source 1084x1451; resolution decision pending."
    },
    {
      "id": "shared-pieces",
      "status": "EXPECTED",
      "detail": "Existing close circle, clock, native capsules and textured progress material differ from generated reference artwork. Title flares are absent. No new pieces."
    },
    {
      "id": "type-and-floor",
      "status": "MEASURED",
      "detail": "All live words use Nunito. Title, age, country, city, tag, bio and timer family reductions preserve lanes and clearances. Timer covers every integer 0–120s from protocol max(120). Several phone font sizes fall below the older UI floors. Measurements are explicit."
    },
    {
      "id": "flag",
      "status": "OWNER PENDING",
      "detail": "64x48 reserved and empty at each measured reference flag origin."
    },
    {
      "id": "not-device-test",
      "status": "LIMIT",
      "detail": "Offline raster composition, not browser or device verification. Integration overlaps and proposals must be resolved before implementation."
    }
  ],
  "notes": [
    "No landscape or game source changed.",
    "Card bases copied byte-for-byte from the registered round-10 candidates; no resolution approval implied.",
    "The old stopwatch, pin and outlined plane remain historical files only; no stage-2 element references them.",
    "Stage 4 replaces only the three print plates, normalizes their size, and removes print text nodes. All non-print layout values, hit targets, states, avatars and shared art remain unchanged."
  ],
  "printContract": {
    "drawnSize": {
      "w": 150,
      "h": 193
    },
    "basis": "Samantha upper reference print: measured 150.15 × 193.04, rounded 150 × 193 as in round-10/stage-2. It contains the ordered GOOD VIBES caption and a full 41-unit caption band. The same size is used for all prints in every theme.",
    "commonAcrossThemes": true,
    "centres": "unchanged reference-boxes.json rotated-box centres",
    "rotations": "unchanged reference-boxes.json",
    "window": {
      "x": 7,
      "y": 8,
      "w": 136,
      "h": 144
    },
    "layerOrder": [
      "print.0 (plate then victory portrait), z120",
      "main happy portrait, z130",
      "print.1 (plate then thinking portrait), z140",
      "print.2 (plate then flirt portrait), z150"
    ],
    "captions": "fixed graphic lettering in the three plate pixels; never profile-specific, translated, hidden, rendered as text, or tinted",
    "avatar": "existing imageCrop preprocessing retained, then objectFit cover / objectPosition 50% 0%; preserve alpha and clip exactly to the window",
    "files": "piece.path is the publish copy; piece.master is authoring-only; never ship masters"
  }
}
